import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3ed0734e/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const MdxIcon = makeShortcode("MdxIcon");
const ArtDirection = makeShortcode("ArtDirection");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The color palette for data visualizations is a select subset of the IBM Design Language color palette. It is designed to maximize accessibility and harmony within a page.`}</p>
    </PageDescription>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` This guidance is a work in progress. To see our roadmap, make feature requests, or contribute, please go to carbon-charts `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts"
        }}>{`GitHub repository`}</a>{`.`}</p>
    </InlineNotification>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Categorical palettes</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Sequential palettes</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Alert palette</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Gradient use</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "resources"
    }}>{`Resources`}</h2>
    <Row className="resource-card-group" mdxType="Row">
  <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
    <ResourceCard subTitle="Data visualization color palettes (IBM internal link)" href="https://ibm.box.com/s/3mt8fshtgy70r7rhxjhfo3gbdt0n3x5y" actionIcon="download" mdxType="ResourceCard">
      <MdxIcon name="sketch" mdxType="MdxIcon" />
    </ResourceCard>
  </Column>
    </Row>
    <h2 {...{
      "id": "categorical-palettes"
    }}>{`Categorical palettes`}</h2>
    <p>{`Categorical (or qualitative) palettes are best when you want to distinguish discrete categories of data that do not have an inherent correlation.`}</p>
    <p>{`The colors of this palette should be applied in sequence strictly as described below. The sequence is carefully curated to maximize contrast between neighboring colors to help with visual differentiation.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "469.44444444444446%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/2ecded13870cefb8151046afc86705de/09548/palettes-14catsm.png",
              "srcSet": ["/static/2ecded13870cefb8151046afc86705de/d6747/palettes-14catsm.png 288w", "/static/2ecded13870cefb8151046afc86705de/09548/palettes-14catsm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "141.44736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/a6097128bc2bc2d44cc4ff3270c1765a/fb070/palettes-14cat.png",
              "srcSet": ["/static/a6097128bc2bc2d44cc4ff3270c1765a/d6747/palettes-14cat.png 288w", "/static/a6097128bc2bc2d44cc4ff3270c1765a/09548/palettes-14cat.png 576w", "/static/a6097128bc2bc2d44cc4ff3270c1765a/fb070/palettes-14cat.png 1152w", "/static/a6097128bc2bc2d44cc4ff3270c1765a/fb755/palettes-14cat.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "141.44736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/a6097128bc2bc2d44cc4ff3270c1765a/fb070/palettes-14cat.png",
              "srcSet": ["/static/a6097128bc2bc2d44cc4ff3270c1765a/d6747/palettes-14cat.png 288w", "/static/a6097128bc2bc2d44cc4ff3270c1765a/09548/palettes-14cat.png 576w", "/static/a6097128bc2bc2d44cc4ff3270c1765a/fb070/palettes-14cat.png 1152w", "/static/a6097128bc2bc2d44cc4ff3270c1765a/fb755/palettes-14cat.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
        <Caption mdxType="Caption">
          <p>{`Complete default categorical palette in light and dark themes`}</p>
        </Caption>
      </Column>
    </Row>
    <p>{`You can override the categorical sequence with one of the following palettes if the exact number of data categories is predictable.`}</p>
    <h3 {...{
      "id": "light-theme-alternatives"
    }}>{`Light theme alternatives`}</h3>
    <p><strong parentName="p">{`1-Color`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABuklEQVQ4y5VSv0vDUBDOKO4FwX9BwUkcddTNioMVRxc7dnHW0cUOBZc6FOzkJII4iVJFjaDVNtoG0aS2NTQa2pg25tfnew9Ta7W1fnB5x+W77929O87zPPhwie+1GQP1WzidePTk6Of5ScarUqR0tMMnN+p1lAoFmIaB3+DzmGC6ZOBEesNNxYJl27CJmabJzCe+6jqOslkc53KQVBW2ZbH/jUYDrut+VWgT/nhcRN+ajOGEhnupgPOzU2QyWeRIsi+YIn4gHAY3O4tIMolHUQR/cQFBEJhwU9Ai4iObZXCrBQxuVFBUVIj5HG7v7qAoSrOlvXQaXDAIbnISi/E41HIZWSImEmFaZVPQcT2sHOtY2NUQOaji3SY3eC5r3XEcNgCKa1nGXCyGmWgUiVSKxSzSNn2eb0PBX2iddlfa51Dog6pqBS8vKvzloLHfVoLGmXVbG+o8SM94kBVoNZMkeD9u9boItFfPme8OQsuHGJhIYjS0C+E2j6urS/A8D0mSOiZ2AhMcmt4GF1hH/2gCj3KRrEKGrYOmaf8XtB0XU0v7pMItjM3voKob0PUaMZ1NsLX1ngR7nV6v+AAivc6u7zv3kQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/090695ad8d8ffde9d026999612420791/09548/alts-light-1sm.png",
              "srcSet": ["/static/090695ad8d8ffde9d026999612420791/d6747/alts-light-1sm.png 288w", "/static/090695ad8d8ffde9d026999612420791/09548/alts-light-1sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.789473684210527%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAl0lEQVQI122MQQqCQABFPWIE0QlatI7uIR7CRdAqCIqgE7SxIFu4UZKgGRiNatQZX2UQFj34f/EWzzGlBlvQxhoDr7Wdtc/TX66ua35x/EAxmAvS9IiUspHbOKbjumzCEHkWjbvrit5ohT/boeQJXZR/o85kf2O4VEghyPP8HUwSup5HEEVcsuwT7I/XTBcH9FVRVuZv8AERreCzZv7S6QAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/b815b4ea229ffa075b44d9b62f75851f/fb070/alts-light-1.png",
              "srcSet": ["/static/b815b4ea229ffa075b44d9b62f75851f/d6747/alts-light-1.png 288w", "/static/b815b4ea229ffa075b44d9b62f75851f/09548/alts-light-1.png 576w", "/static/b815b4ea229ffa075b44d9b62f75851f/fb070/alts-light-1.png 1152w", "/static/b815b4ea229ffa075b44d9b62f75851f/fb755/alts-light-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.789473684210527%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAl0lEQVQI122MQQqCQABFPWIE0QlatI7uIR7CRdAqCIqgE7SxIFu4UZKgGRiNatQZX2UQFj34f/EWzzGlBlvQxhoDr7Wdtc/TX66ua35x/EAxmAvS9IiUspHbOKbjumzCEHkWjbvrit5ohT/boeQJXZR/o85kf2O4VEghyPP8HUwSup5HEEVcsuwT7I/XTBcH9FVRVuZv8AERreCzZv7S6QAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/b815b4ea229ffa075b44d9b62f75851f/fb070/alts-light-1.png",
              "srcSet": ["/static/b815b4ea229ffa075b44d9b62f75851f/d6747/alts-light-1.png 288w", "/static/b815b4ea229ffa075b44d9b62f75851f/09548/alts-light-1.png 576w", "/static/b815b4ea229ffa075b44d9b62f75851f/fb070/alts-light-1.png 1152w", "/static/b815b4ea229ffa075b44d9b62f75851f/fb755/alts-light-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <p><strong parentName="p">{`2-Color`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "140.2777777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAACXBIWXMAAAsSAAALEgHS3X78AAAEOElEQVRIx51WXWibVRj+wAsvvLFiHYhuVBHGFERFkA1aJqK9cJUN5hxTVqg/Q5ZeVC+GbsgYimuncRNEcGpJ13Wtdheyttm6Ttttabu0SfO7LI1pkqX5/2l+v598yeM5p03apE3X+sLJ+XLOk+ec5z3Pe75whUIBLEiXzxdAv69qdHIJVg3DKEjP0Q9f4D4i8QDWi0Qyjnm/G6KcWXO+SMoIHfoozLfDcFvSyGazEAQePM8jnU5DknIMGPFlYLoVhF0bRzxE5gWKE5HJZEgvLO9Q4vNQNpvQvG0UJ97Uwe12Q6vVYmpqChaLBdFIjIE1/QEc2X4TH9aN4UaPE1a7AXcmF3FOp3OZMCfm8XWjDs2P/YOvGnSIRCJwOBwMRHdZjBtdARx+SoOWugnc6vcjFJ2H3e5AIBAoz6Gcy+On76041noH5741s+1LksQalS+JEgNPD7nwzb4BdBxUwzx2n4zISKfSZXJZDkXy8GJvJ7hfz2L7YD9cLheTMTU9Db1ej0g4zIAjnX048Mhz2PfQVgyd74bBYsbE+ARmZ2dLhGyHYj6PbV0qcN91YMvFbvj9flitVpa/ZDJZsstfyt/RwD2K3VwN1L9cQjAahsVsZoSyLK/IISH8YkqL/SPD+HxyvCwftOXJPA391TG0v6uA8v022DS6RU8Soko8hw1EYYl0Ld9VPnN0B75wCIFYBPI6pMmFBQS9Hgjp5CqSVcb22ZzwW/5F2h8tSSxKkJe+h5M8DG5iqUgWGWlZJsWX24a4/e+WDlx45hAGGo9hbm4Oo6OjzNxmknSzxUqQOahINT151oW681FcMkThsBpx13aPOaKsUmRBwuVdCvzI1aP3hRaEiU0MBgOMRiMSiQRy+cXVz2kT4E55wLUHoTKl4HfNwmi2sFNeqYrL52QMf9yBvgYFrrWcZhagpqZVwiQtperyvRR2qjzY3e3FdWeanjEyxPjU/GWnLPEC2g8ocOjxV/Blw0FWdjpiaJPJhFQqVbQhejS3sbX1KJ749Aj6xjVw2u0wkZR4PJ4KYxNCxY63sJN7GIdrX4XP52O5o4TBYLBE+INaDa6pCdyeJvw8PAwPWXiGpIbWfJlkOZeD8oPP0PbyHpx5r5VJzpExKpn2xVPum5zES8eP47WTJ6E2GNlYhl11QvkpP9DUK27kB+FKPozHYkjE43S05K1Kf1VbaM1XgJfkaj4UQlYUq65cjaAyOIkM7h8cwLO9PXj7+jV2KDabDTMzM4jFYlV/WC04gUh7uvM3cGdOo7bnArxeL/Q6HbsL4zQNmyWUCGHjVTW2dHfh9aErEIlsenI8aSvvuY3vUJTxyamb2LH3D+xtG2G1TMuJepG+XzZNyAsynn/nT3A1StTWX2SEtOCp5AVyZW1eMnlJvfHRIGp2qVDffIUZOplMkJb6f5IpeCElkn8OPOJJYd2beSPxH7r89OmmefSEAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/b902856892f3b6cec8a53cf66187ff34/09548/alts-light-2sm.png",
              "srcSet": ["/static/b902856892f3b6cec8a53cf66187ff34/d6747/alts-light-2sm.png 288w", "/static/b902856892f3b6cec8a53cf66187ff34/09548/alts-light-2sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.086206896551724%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAyUlEQVQI11WNy2rCYBSEfUHfwlV9jeLGgggWxK0bN6IWEQQRN0JX9RaMBZsWwfsFbRpj8l8+/2RlZ3WGb85M4uh4uAcfjcT7lWwXPmEYoLXm8r3GO7soJdj/SRZngRIhQik+Lwfcm/lTmkhRPlIin7No1Eem0MPuryg8NVnvlkT8LZXhvdExMUFlvCFdHXA97XADQbLcom/N0GbgX2HOGtN1vmLjDKfUXkr4wS32tWyJ2cckvnu2zWu7DVIYLnkuDpj/bA1R6IfCOy9m20OuzUNUAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/22b9e8d541a84dd6b969ccf81983bd85/fb070/alts-light-2.png",
              "srcSet": ["/static/22b9e8d541a84dd6b969ccf81983bd85/d6747/alts-light-2.png 288w", "/static/22b9e8d541a84dd6b969ccf81983bd85/09548/alts-light-2.png 576w", "/static/22b9e8d541a84dd6b969ccf81983bd85/fb070/alts-light-2.png 1152w", "/static/22b9e8d541a84dd6b969ccf81983bd85/fb104/alts-light-2.png 1728w", "/static/22b9e8d541a84dd6b969ccf81983bd85/cf416/alts-light-2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.086206896551724%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAyUlEQVQI11WNy2rCYBSEfUHfwlV9jeLGgggWxK0bN6IWEQQRN0JX9RaMBZsWwfsFbRpj8l8+/2RlZ3WGb85M4uh4uAcfjcT7lWwXPmEYoLXm8r3GO7soJdj/SRZngRIhQik+Lwfcm/lTmkhRPlIin7No1Eem0MPuryg8NVnvlkT8LZXhvdExMUFlvCFdHXA97XADQbLcom/N0GbgX2HOGtN1vmLjDKfUXkr4wS32tWyJ2cckvnu2zWu7DVIYLnkuDpj/bA1R6IfCOy9m20OuzUNUAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/22b9e8d541a84dd6b969ccf81983bd85/fb070/alts-light-2.png",
              "srcSet": ["/static/22b9e8d541a84dd6b969ccf81983bd85/d6747/alts-light-2.png 288w", "/static/22b9e8d541a84dd6b969ccf81983bd85/09548/alts-light-2.png 576w", "/static/22b9e8d541a84dd6b969ccf81983bd85/fb070/alts-light-2.png 1152w", "/static/22b9e8d541a84dd6b969ccf81983bd85/fb104/alts-light-2.png 1728w", "/static/22b9e8d541a84dd6b969ccf81983bd85/cf416/alts-light-2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <p><strong parentName="p">{`3-Color`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "187.5%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/6829940d394a292b7455dd4fa77852d9/09548/alts-light-3sm.png",
              "srcSet": ["/static/6829940d394a292b7455dd4fa77852d9/d6747/alts-light-3sm.png 288w", "/static/6829940d394a292b7455dd4fa77852d9/09548/alts-light-3sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "19.827586206896548%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/UlEQVQY01WOzU7CUBCFeVJfQlnojidATFzIio0QF00MG0PYQAimkmg1sSWhwQSQWgoaftrCbW/vZ1vjgtnMnJyZb07BdxPCdYRUkv3Gx7M/EUIgZczOVYSbiJgE9b1FDqdsAx8ZxzyZJo7nkUhJVkqpvBe0O5de54MIwcaweSlWmDlOuhDTbMzRe2MkB5yhR6em47iZl3B+2qDdGiCi8BhYKt+gNR/SFLB+NngtXrBYrXLz5PKWerufrdN9DzirTvhZfuW6VDboPo7ShIdjoF1rMem/kcmpaXFfuSII/75e1y10Y5ZOCe4oYKDN2Ysw41EdW5jLRWol+e0/8BehGSNzHBrUwgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/bb2173dd0316bbcea8ed4f923dff064d/fb070/alts-light-3.png",
              "srcSet": ["/static/bb2173dd0316bbcea8ed4f923dff064d/d6747/alts-light-3.png 288w", "/static/bb2173dd0316bbcea8ed4f923dff064d/09548/alts-light-3.png 576w", "/static/bb2173dd0316bbcea8ed4f923dff064d/fb070/alts-light-3.png 1152w", "/static/bb2173dd0316bbcea8ed4f923dff064d/fb104/alts-light-3.png 1728w", "/static/bb2173dd0316bbcea8ed4f923dff064d/cf416/alts-light-3.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "19.827586206896548%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/UlEQVQY01WOzU7CUBCFeVJfQlnojidATFzIio0QF00MG0PYQAimkmg1sSWhwQSQWgoaftrCbW/vZ1vjgtnMnJyZb07BdxPCdYRUkv3Gx7M/EUIgZczOVYSbiJgE9b1FDqdsAx8ZxzyZJo7nkUhJVkqpvBe0O5de54MIwcaweSlWmDlOuhDTbMzRe2MkB5yhR6em47iZl3B+2qDdGiCi8BhYKt+gNR/SFLB+NngtXrBYrXLz5PKWerufrdN9DzirTvhZfuW6VDboPo7ShIdjoF1rMem/kcmpaXFfuSII/75e1y10Y5ZOCe4oYKDN2Ysw41EdW5jLRWol+e0/8BehGSNzHBrUwgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/bb2173dd0316bbcea8ed4f923dff064d/fb070/alts-light-3.png",
              "srcSet": ["/static/bb2173dd0316bbcea8ed4f923dff064d/d6747/alts-light-3.png 288w", "/static/bb2173dd0316bbcea8ed4f923dff064d/09548/alts-light-3.png 576w", "/static/bb2173dd0316bbcea8ed4f923dff064d/fb070/alts-light-3.png 1152w", "/static/bb2173dd0316bbcea8ed4f923dff064d/fb104/alts-light-3.png 1728w", "/static/bb2173dd0316bbcea8ed4f923dff064d/cf416/alts-light-3.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <p><strong parentName="p">{`4-Color`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.55555555555554%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAfCAYAAADnTu3OAAAACXBIWXMAAAsSAAALEgHS3X78AAAElElEQVRIx51Wa0xbZRg+8Yf/3A/iAokxGhPjsuiPJUaNAW9bMoQQE3Xq4g+cTLwwg4ub6BY3JUsWs0Syi7iEoRMHyAAHOkBhYVmXjqv0ulI6yr1teqNdS+k5p6fn8fteOIx2FIdvcnpOv+/9nvNen/cIqqqChN3UZBL8/1qXJslk5n1+F/jPnNcDbyiI9SQcCcHlmYakxNbc10AFlb3RPWzHzDUDAiYnRFFEPB7H4uIiPS8sLJD5Qc8iLNe9cAyFEPLFmQ7flxCLxUh/xcJEXMLfbxxFzQMFuPRsGSYnJ9HT04P+/n5YrVbY7WNMNYEbrV58vPU69j6mQ2/jBEYdZgwODMFoNGJqauoOoCLJaM4tx6n7duC3bR8hFArh1q1bcDgcZKUmV+s8KHlIj9JH+qBvdcMXdGHM7oDP50txW0gmFFgOn4V+1yEYDp6GJEkQJZHAFEWhJHDp657Fl7t7cKT4Kgx6N1tRkJATFJIkS+YKIDsFb9lniO8sAsoPwMGsGxwawsjICCKRCLT81rR04f5thRC27EBtSwccdhuMJhOGh4cp1ncAEwnEPyyHkpcP7N0Hv98P682b5Da3VrPw1Pk2CJtzIWTnobapEwG/l3Smp6dTLVQZoKfyOCaLS+H6upJAEmxNZJnjLivLyk29fXjqvQo8/cEhdPaN0FqcWcb1NTAClNjBY7veweubsvD583mUjIGBARgMhhSXz9ms2FR7Fg+2NKLJyZJmNmOAhYZbmQIos7eUPbEFuYKAPdk5CAQCpGS328l9DfC4cQTC999BqD6JaosZ/ukZ2JjO7OxsaqcoLFNn3j+AL54pRNW7+yDLMl2a68pyDC87xrHzQjMK6pvROzHFe5BVg7Qc59UxZM9d1RLavgVu/AQKsolljxcsz3TQHyBlsduC8O5qoLQBC70WmBw2mI0m0nE6navrEGisiOL0myKaK1QqVIvVgrGxMbKU1ymXSOsQpp6rhPflE7jdZcSEZxYmg5HCk2JhUlExeBHoPqmirx7kAu9NmYViiV6WXJYHJxE92o5I5R8QTTMQVQVSWpaJHNI44y4GIUVVXZeJVtMb0VfA50coEFw5mFzmxdXKmXgyfZ8AXaw8XCz4MRazdIUluzODpIsgs8X89kvIqjuPF7o64Ha7YbPZqLCDwWDGg5lEkJh7j9b9DKHqBHKaGuByuQjMzDohHA5vHFBmgK92/oWcXy9g++WOpcImCpOolzcMKEoKSo7o8HjhRRR9eoWKdHR0lIpbI88NAcZFBVtfa4GQVYXNLzYQnXOX+bXa5XsFFWTWCQWfdCP7pXq8UtJJhcoHj0aaG7aQ93Lnj0G0fCPi2jlQUsad40RjPDF8xmzESoF1EBoqwvjhLQm/fwV4PB7W8P8QOczPz99FoP8JmGSAOsYybcfYZGMW8j6OLkQp25naa11APkZ1+2vYKD2IK8VV8Hq9NI85i2jjNJ0A1gXkg759+36cEfLQ9OQezM3NQafTQa/XUzz5mOREe8+ASUZTHUWH8cvDb+PP/IqVz49oNPr/XOaK8eBtxDxBLPrDa1LTemSQLv8C06HU8poeLT4AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/40c3945842f2ef0e3df2daa8de1d70f8/09548/alts-light-4sm.png",
              "srcSet": ["/static/40c3945842f2ef0e3df2daa8de1d70f8/d6747/alts-light-4sm.png 288w", "/static/40c3945842f2ef0e3df2daa8de1d70f8/09548/alts-light-4sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.828947368421055%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABlklEQVQoz3WRvU8UQRjGt/VvsPAvwMKExFhSU2mNBZWBwkSIiYWxsKEyFhDUhEBCi4lAAo3BoMXGmCMEL+HwDm739vbjbu88doFzv2Z+zO0aFXK+mUnePPPLM887owmulpCClL7q5B9t0Mk0hST9C0qpluR6aZ9n3+A0bQzD4OLiHCkkm69N9A82jtfA9zs5WGq5TOx+pGI36bRaxSVDTLW1kYdYponreepQkGWC5w90Vue+47ZNeqdhDm7XTW4sLPOtdozvOmRC/A56zZDJKRr1Ou1OkSRVo42OP2Lm5Ty+SvWzF+T61hcT7fZb9NIRfvuq4b+m2tLdezRUQr/bLQwVeOfVAk83tuk6Nmfn/Vw/2At4PHlC7UcL2zaJ42R4wolbI7iOgzd4F2WWKWBsfZ0Xuk7PdQmCsxx0ywmbT35hVX01jUccJcMTvn8GlmWr3SjGUJ9yOr1K+O4T1aZB2/Fy0NopsXLzPkdf96lbJmEQDjes7EqiKEaIrACUYbRzSFxuEmUJIi300PAoL27Q74X//ZBBXQJgfkuzl/kvWgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/00b6d3bb9891cb9630d329312ed28de1/fb070/alts-light-4.png",
              "srcSet": ["/static/00b6d3bb9891cb9630d329312ed28de1/d6747/alts-light-4.png 288w", "/static/00b6d3bb9891cb9630d329312ed28de1/09548/alts-light-4.png 576w", "/static/00b6d3bb9891cb9630d329312ed28de1/fb070/alts-light-4.png 1152w", "/static/00b6d3bb9891cb9630d329312ed28de1/fb755/alts-light-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.828947368421055%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABlklEQVQoz3WRvU8UQRjGt/VvsPAvwMKExFhSU2mNBZWBwkSIiYWxsKEyFhDUhEBCi4lAAo3BoMXGmCMEL+HwDm739vbjbu88doFzv2Z+zO0aFXK+mUnePPPLM887owmulpCClL7q5B9t0Mk0hST9C0qpluR6aZ9n3+A0bQzD4OLiHCkkm69N9A82jtfA9zs5WGq5TOx+pGI36bRaxSVDTLW1kYdYponreepQkGWC5w90Vue+47ZNeqdhDm7XTW4sLPOtdozvOmRC/A56zZDJKRr1Ou1OkSRVo42OP2Lm5Ty+SvWzF+T61hcT7fZb9NIRfvuq4b+m2tLdezRUQr/bLQwVeOfVAk83tuk6Nmfn/Vw/2At4PHlC7UcL2zaJ42R4wolbI7iOgzd4F2WWKWBsfZ0Xuk7PdQmCsxx0ywmbT35hVX01jUccJcMTvn8GlmWr3SjGUJ9yOr1K+O4T1aZB2/Fy0NopsXLzPkdf96lbJmEQDjes7EqiKEaIrACUYbRzSFxuEmUJIi300PAoL27Q74X//ZBBXQJgfkuzl/kvWgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/00b6d3bb9891cb9630d329312ed28de1/fb070/alts-light-4.png",
              "srcSet": ["/static/00b6d3bb9891cb9630d329312ed28de1/d6747/alts-light-4.png 288w", "/static/00b6d3bb9891cb9630d329312ed28de1/09548/alts-light-4.png 576w", "/static/00b6d3bb9891cb9630d329312ed28de1/fb070/alts-light-4.png 1152w", "/static/00b6d3bb9891cb9630d329312ed28de1/fb755/alts-light-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <p><strong parentName="p">{`5-Color`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "94.44444444444444%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAAAsSAAALEgHS3X78AAADv0lEQVQ4y31UbWhbZRS+2x//if4Rpg5xmDn/qAibUOfEMSbzjzpQBLcWpnZIBet+W+lmnYsUEUw3260VZxEZXVZJocwNcV1tl+XrJk3u8t0k/UjS21S3fN6be+/jed+bhHZWL5y8Se7D857nnOccwTAMNB9dN8B+3x8AO02MRhh9Uwz4KbCP5dwC5LUc/u8pFe8ht5yGppY3fd8k5YQJ/xqkWRmZUAnVahW1Wo1HqVSCqqocmF0p4vpsClPuZSzmi6hVK4RRUC6XN2ZYV3X0vSmiY/sN9Bz0Ip3KwO1xw+VyIRQKIb8ic/AP4xEIlu8hPD0E6wUXAj4nPF4fvF5v69IW4anXXGh/+Do+2+uCvLKKWCyGRCJh3t6QNHyZCB+1QXjsLPpHRBTkRUh3wlhaWmqRcUJNM3D+63l8/pEE26kEl6HpGhQ6FUXhjWLPVdcCXv7EgX3dE7DfTLL2oFI1S7NBskqEr4wV8IAti92X/kY6k4Hz1i0ESW48Hm9lOJqIYsuPg9h6cQgD0hwS9N5JZQmHwxu6LShEuPviGoSvcnhm5C/kZRkRAkmShNXV1RbhUDQM4dx3EAYHYBV9yKdSCASD/FJd19fVkCS978hgz3AU79pTqJFM5rtKpQJN07jn2HMtnsSrIz9hP8W4FDYJGiT1ep0Ht41KXw6c/gIPHmtHW28PFqnIflHE3NwcZFlu+Sx9ZRpjO96D/amjCA1PIBCRcPPGFHw+H8cmk0mTUCHC7SdOQHj9EB7q6sJyNsvlRqNRFAoFGh8zw/DoNdi27MfA1gMQbVcwn12Ay3n7311WSdaR/m/xbFc33vrSyrvGfMUMziQ3CecnZ/Hzix/yiNn/4P9VypUNHuSEel3DdLsVjuc6Mf1OHzLpNGZmZiCSFGbsIMlhlE6HAx9YLDi+axcmh0cQJq96PR6uxNwDZmMETanjlxc68Y3QhtGd7chnczQBHj4BTLLKm0Q+HDyPvYKAfRRjZ6xYyud5rVl5mg1pZfj78X6MvfQxfjvSB63RMSZ5/SZxTUyi+/k9+JRi+tLlhuQyx61fEDR6Kk6/cRjHHn8CJw8eQpJGLkAy2c3FYrEJRUY0YO8xMN4LSFMVJObDiESiCJIXm7JNQpLUucOCNpLS8cg2ZGhSRL8ffoosdbxJGPuTzH3UwIUOIHBVRTx1B263l+Ob42fOMmV45vDb6HzSgl7KkNWMmZtlZwIbGfpZdgZ+PUnr7raOWr2Eu3fvmU64fx8qbAeWylBoOv5rcdK+QF1hQRtb3xzDzn8A9ogqvx9KEbsAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/7460d46eb43e980e29e85fee9a2a9f27/09548/alts-light-5sm.png",
              "srcSet": ["/static/7460d46eb43e980e29e85fee9a2a9f27/d6747/alts-light-5sm.png 288w", "/static/7460d46eb43e980e29e85fee9a2a9f27/09548/alts-light-5sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "44.73684210526316%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABTElEQVQoz5WRvU7CYBSGexNObgwmOngDLq4m7g4ORuOmCQuJ3gAxTmIc9AZAExnsigo4MBiwkohY1EAppf36Z0lQaenPa/vFEDfqu51nePKecxjHteFhjL/xfRdBYE/mIAgQN0yNVZDbewEhBERVKWy1Lawlb1Gtd2DoBP6vMBJPkzP5HMHO5jMkqQfdMCisvmqYWc/i+p6HqSmIHHFkVJh5/MbSpYWeKELXdQprhoZZ9hzFtxbMsLn3n4YHhTIW0keQ+30MrAGFclPA2co+GhUOQk/E53AYX5i9YLGxnYIYNlRkmUJS53E6v4pGsQJi6JFpIpsq5E+uUFhOQRAEKIpC4TvHYSuRQK1Ughre1fe82N9m8ulD7M4tQuh2YZofFKptB7mkCf5Bhih14Djj+Cs/le/AZo4xGo1g2w6FX+EpmzeApTkYu3ZsWZQfA4ygdnQuViAAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/aea86cca2016de611b25880194f640e2/fb070/alts-light-5.png",
              "srcSet": ["/static/aea86cca2016de611b25880194f640e2/d6747/alts-light-5.png 288w", "/static/aea86cca2016de611b25880194f640e2/09548/alts-light-5.png 576w", "/static/aea86cca2016de611b25880194f640e2/fb070/alts-light-5.png 1152w", "/static/aea86cca2016de611b25880194f640e2/fb755/alts-light-5.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "44.73684210526316%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABTElEQVQoz5WRvU7CYBSGexNObgwmOngDLq4m7g4ORuOmCQuJ3gAxTmIc9AZAExnsigo4MBiwkohY1EAppf36Z0lQaenPa/vFEDfqu51nePKecxjHteFhjL/xfRdBYE/mIAgQN0yNVZDbewEhBERVKWy1Lawlb1Gtd2DoBP6vMBJPkzP5HMHO5jMkqQfdMCisvmqYWc/i+p6HqSmIHHFkVJh5/MbSpYWeKELXdQprhoZZ9hzFtxbMsLn3n4YHhTIW0keQ+30MrAGFclPA2co+GhUOQk/E53AYX5i9YLGxnYIYNlRkmUJS53E6v4pGsQJi6JFpIpsq5E+uUFhOQRAEKIpC4TvHYSuRQK1Ughre1fe82N9m8ulD7M4tQuh2YZofFKptB7mkCf5Bhih14Djj+Cs/le/AZo4xGo1g2w6FX+EpmzeApTkYu3ZsWZQfA4ygdnQuViAAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/aea86cca2016de611b25880194f640e2/fb070/alts-light-5.png",
              "srcSet": ["/static/aea86cca2016de611b25880194f640e2/d6747/alts-light-5.png 288w", "/static/aea86cca2016de611b25880194f640e2/09548/alts-light-5.png 576w", "/static/aea86cca2016de611b25880194f640e2/fb070/alts-light-5.png 1152w", "/static/aea86cca2016de611b25880194f640e2/fb755/alts-light-5.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h3 {...{
      "id": "dark-theme-alternatives"
    }}>{`Dark theme alternatives`}</h3>
    <p><strong parentName="p">{`1-Color`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACGElEQVQ4y5VTO2/TUBj1QhnIy762r19pnQqahyoncZoUCMZ5CcKCBL+CDdgQEgJViIEBiQEhJOgeylLB1ImqSAxVEQsbIxL9A50P97NjkxSBynD8Xd97vnO/15V0XQdTtQg656D/WWiallpFVaHR+hhnlifRx6+vol4rQ1cKUMlJHJIl0DlZd3ERF3wfK0uu4LH0POEnohLdVlofYTm4DtvvwTAtmKYJy7Jg23YckXDipRLsXg/6pS7UagUOnTsOHAEuMksj5JaD8sYO/G1gdfMHGq02ro2vIggCdLvCWRB5oQC5exGn3k2w8GkX2bu3EXY6uDIeIwzD6OIkG0kXEXmvvmN9D6hPjlDzGgiEULvdiYlUo1wOymiE05/3sPD1ANn793De8xD2++gIYcrmdw25gXO3nqP28ANW7myCWzYMrqdpaNSoggzW8pHZeITMk8eQb96AwRhMKy7PXFOi7uUyULJnoMn5WGSKtINkKaV8PoaizPHmmkKRVKpVlCuVuAFUM7HHpyMUkcmJ1hQ14V9jQwu/2UazsYaSezYSUkQEyjSKhJzMXzqHM3uzwpIlavbswVt8nPzE1ssvaPlronOXMRgMMBwO4Yniy7L8R0R/QyS4/eYbDg+A/fdHaNSb0Sj0e30Ui8W5GTuRoGGYeP10B7tbh5i82BdpL8N1XSyJF3G84CcSjN8yA2OKGM74STHGIvyvGOEXwnJ5bJ/4B7cAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/bb345be8afe7572c09ec356e17f54cff/09548/alts-dark-1sm.png",
              "srcSet": ["/static/bb345be8afe7572c09ec356e17f54cff/d6747/alts-dark-1sm.png 288w", "/static/bb345be8afe7572c09ec356e17f54cff/09548/alts-dark-1sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.789473684210527%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAv0lEQVQI11WOsWrCUBhGXYVCzP3vvblJjIlauVaqoF0c2jeog+DgKgi+gdCxYMW59B0Eh+IbHjUQweHw/5zh8NWyJCa1QhiGaK0xxpA4R3FFrk5EShdFES62KAlRSpXOWlve6r9Ra882DL5OjEZDnns9dBBg3iY8HX7wH++8+j5KC2nS5G93Zjlf8zLwFHlRDqhC92D+ucFvj/S9J2u1MEEDmYyp73d0p1N8p4vcgmnG7/c/i9mKvMhwLn5YVnEBtt9XGw9ZmeEAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/854a3ea74c290739979a4a2340f1f18d/fb070/alts-dark-1.png",
              "srcSet": ["/static/854a3ea74c290739979a4a2340f1f18d/d6747/alts-dark-1.png 288w", "/static/854a3ea74c290739979a4a2340f1f18d/09548/alts-dark-1.png 576w", "/static/854a3ea74c290739979a4a2340f1f18d/fb070/alts-dark-1.png 1152w", "/static/854a3ea74c290739979a4a2340f1f18d/fb755/alts-dark-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.789473684210527%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAv0lEQVQI11WOsWrCUBhGXYVCzP3vvblJjIlauVaqoF0c2jeog+DgKgi+gdCxYMW59B0Eh+IbHjUQweHw/5zh8NWyJCa1QhiGaK0xxpA4R3FFrk5EShdFES62KAlRSpXOWlve6r9Ra882DL5OjEZDnns9dBBg3iY8HX7wH++8+j5KC2nS5G93Zjlf8zLwFHlRDqhC92D+ucFvj/S9J2u1MEEDmYyp73d0p1N8p4vcgmnG7/c/i9mKvMhwLn5YVnEBtt9XGw9ZmeEAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/854a3ea74c290739979a4a2340f1f18d/fb070/alts-dark-1.png",
              "srcSet": ["/static/854a3ea74c290739979a4a2340f1f18d/d6747/alts-dark-1.png 288w", "/static/854a3ea74c290739979a4a2340f1f18d/09548/alts-dark-1.png 576w", "/static/854a3ea74c290739979a4a2340f1f18d/fb070/alts-dark-1.png 1152w", "/static/854a3ea74c290739979a4a2340f1f18d/fb755/alts-dark-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <p><strong parentName="p">{`2-Color`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "140.2777777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAACXBIWXMAAAsSAAALEgHS3X78AAAEyUlEQVRIx41Va0xbZRhmbjNYoLdzTs/pDUrpaaH0AoVS61oobaGjg8YE5mDCkDi3RWEYZ0YcGJx4WUxmzIzGLdMEE0Gd27IlXuP8YxSjiLeEaPTHtl8m018z0cQfj+/3QctlzNDkPef0fE+e8z7v+7zfV2QymSCKEiTRBNkkg/2/NWhdIpwg0bNyG4yJMBKK2ENdyAdvQIUgaYlchCAIhTsDCYIIl9uJUNgPu0OBIBr4ej7yOMZFhDJCVRlE1G747ClYLBaUl5fDZrPxu9Vq4wQuexB3u3vQUNmFCnM17OU22GjNbrejoqJiJUNZtOLJzE841Q6MRX6DS3Whvb0d2ewuJBIJ1AXrUaK9E7nQE3g1C5xsBhLuQwhHg8h2dCKVSqGlpYUnwgkVExGGf8HpODDZeJ1/LRqNoincBFmWCSRDJxQj45nAiwngBSJsdj0MX52KeKwZVVVV0Ov1XDqXLJvM6Ei8ht5dn6Kz9XWYzWYuw2q18mAl0QmlSHn6MJX4BJMt7+MeVxcUmwlWi41nxnCsRDxDif5se+k5bPn8A9zx1hk4HA6Sm+VyQ6EQdV9EiUGHkVgO/4y/Axy/jAPRLMKxKHb39CCdTnPJkUhkmZC+oHlzGsXff4fi8++hsrISCQI0NzfD5/NBJrsU68swnuoHnv+S4guMxLuh+mo4zu/3r+2ypCjQHR5G2bNT0D46WvAUqx8Pklxm1GN3KIlL9z+Fc70T6PBH+bu8b/NkSz6ki1hSAkmjgazV8ZfrQyaw1qDHtlINinVlMIhCgWA12VJTKItqvw9qbQ2MsrQhIZPkqnKiPlALZwUVXxT45KzGrJmUWDCMlmATAg73mjFakq6QJQQ4qrzwhdOorIlAtlTwcVw/djxDu9mCS32TuDl2HgsHX0Z1dTVyuRw3dywWQ2ZnB1SnHY7IA4hP/I7k1E2oO4aQbt1BTkgik8nwiSr40KZY8OvwWeDEV7jx2Cy3DSNiVnA6nZBpXTRoUJMZR+YUeLgTwwjXe5FMtXFrrcnQTJIuDD2NxSNv4PLQM7yzCnWemZtPCnVS0GngTTyEtvFFJI8uQI3cB0UywEKzzLBrCJnDL8zO4I/r1zD32RWoqsrltra2wuv1cqCurBS5gf14e+EaLi7eQMeefagL+LmSeDzOy2Q0GlcIf56fB/v9efUqN3ZbWxsaGhqWfEgZlGruQv/oMcz9DXz9L9C9fwRBXy3h2lFfX1/Ibkkyze6709P4cW4OF2dmOAmbT/aee5AItaUl6Nz7IE5f+QGvfPgNWrt6YGKdp3ozyfmGLI0eXQwGAwyUsrjsKQZYb1jut+X3eczqkVu1wZpQ7fHATbWTlxfyY3cL4Tojr/fgCiFtAp7aWii087BFVmAWq6VsdH5sdK4UCXQxDg5g6+gj2NrfxzfYZDLJd5tAIMBl3e5Q2piQpGnHHkfRyRMoOjLKzZwkyzDCxsbGQpabJpSIcPtgP7YQ2fahfby7tuUdmNXx/2RvSKhYzdh5Yi8GPhrDvWcPFEYvWBfkpvVQw/Km3RyhzYzBj4/i2F9ncHD+OJxk7HQqzU8zNin502zThLJZwZ7ZYRz6dgq95w5zAjYtbAQZIN+UTUtmF4uDDm0XHeq0TeUNy2SuN+1m4j9z9GCK45DBnQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/0685ddbc1a62ac16bf87c54b9eb9d029/09548/alts-dark-2sm.png",
              "srcSet": ["/static/0685ddbc1a62ac16bf87c54b9eb9d029/d6747/alts-dark-2sm.png 288w", "/static/0685ddbc1a62ac16bf87c54b9eb9d029/09548/alts-dark-2sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.086206896551724%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1UlEQVQI11XOP0/CUByFYUY1DhLa29+9t1eqLbEEgtABE+OfVpImhhAXJ6Ksxmh0Yemim1/BEXY+5Et1MQ5nOicnT6NvxxzblEB7ONMhcWcYI6ggYBz3iF2EiMK0U8I4w+ifTvCSE3QYIvXO932UUr9plJNvJsUzNmpykcyoihWDUR9tDJvXLxbTewI5YFg+MX1b0+1EKGtx7wtOL89ph46W5/0d7j/McTcFfqvJdZrxUT5yeFSrasVnVVHkOXu7O1zd3jF/WaJrkVhNvpzRzXqIkn/CLVsUW7UEbF3UAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/514b27ff60c9db40f2e4d969acb4da29/fb070/alts-dark-2.png",
              "srcSet": ["/static/514b27ff60c9db40f2e4d969acb4da29/d6747/alts-dark-2.png 288w", "/static/514b27ff60c9db40f2e4d969acb4da29/09548/alts-dark-2.png 576w", "/static/514b27ff60c9db40f2e4d969acb4da29/fb070/alts-dark-2.png 1152w", "/static/514b27ff60c9db40f2e4d969acb4da29/fb104/alts-dark-2.png 1728w", "/static/514b27ff60c9db40f2e4d969acb4da29/cf416/alts-dark-2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.086206896551724%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1UlEQVQI11XOP0/CUByFYUY1DhLa29+9t1eqLbEEgtABE+OfVpImhhAXJ6Ksxmh0Yemim1/BEXY+5Et1MQ5nOicnT6NvxxzblEB7ONMhcWcYI6ggYBz3iF2EiMK0U8I4w+ifTvCSE3QYIvXO932UUr9plJNvJsUzNmpykcyoihWDUR9tDJvXLxbTewI5YFg+MX1b0+1EKGtx7wtOL89ph46W5/0d7j/McTcFfqvJdZrxUT5yeFSrasVnVVHkOXu7O1zd3jF/WaJrkVhNvpzRzXqIkn/CLVsUW7UEbF3UAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/514b27ff60c9db40f2e4d969acb4da29/fb070/alts-dark-2.png",
              "srcSet": ["/static/514b27ff60c9db40f2e4d969acb4da29/d6747/alts-dark-2.png 288w", "/static/514b27ff60c9db40f2e4d969acb4da29/09548/alts-dark-2.png 576w", "/static/514b27ff60c9db40f2e4d969acb4da29/fb070/alts-dark-2.png 1152w", "/static/514b27ff60c9db40f2e4d969acb4da29/fb104/alts-dark-2.png 1728w", "/static/514b27ff60c9db40f2e4d969acb4da29/cf416/alts-dark-2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <p><strong parentName="p">{`3-Color`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "187.5%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAmCAYAAADEO7urAAAACXBIWXMAAAsSAAALEgHS3X78AAAGn0lEQVRIx5WWe2yT5xXGrZUFSuwkvt/jODiuEzt2HOeeOLFzdyCBClrERWxTB6xqKRQxQBuUtIWuZaUNrLRcxB+gilDUsaotq3aj7L5BJ1aqrevQtu4fNrpOYtufbPvtvK9jy9nYRiK9yRd953u+c87znOd8BofDgdfjxeP24nA4Uf//+7Hb7bicLrxeHy6X+3/GGdRFU3OMaDyM1VGJ1WrFZrPpo65VkLquCQZItSWoWeTDajMXYwpHxSksDVjvS9MUyBH1Z/D5/Hh9XsnGS3V1NW63Rx6w4HeFSFSPkAiMssibwO+Xqjwe+euXZ3wlGdo87B55l0PDsLPtQ1LJVgYHBxgdHaW/v59YrJHyijJ6G9bywjgcSMPKpik60ylGR3ISO0g6nZZWuPKALoeHXe2/5mgGnmj9E7GGBOneHpqTzbpkp8NFlXUhnYvW8VwWnu+DFY1fIZYMk830EwqFiq3RJasHlnYf59ODF1nRcxq/L4Db45ZSVLlCgN2J2VZBS3CEXT3fknOBXMODOL02TZCKUdmp8nWGdrkoO7CPu95+k09MnyDW1CRvztDb20tDQwM2ebvJUsXyZC8fbz8Fk69zYGIDrT2d3LtsGdlslozEd3d3Y7FY8oDzjx9l3qWfcNe5V4kK4PDQEL19fdTV1WEXBsvNlaxJDcHub8DeH3B46SNEEjHp4Yj0OIbT6dQnn6FK95n9uKencU1N4VaMyQ2PsKzKcYrmjAK4LNXHr3ac5IPtJ9k+vEZn7Zkpd5ZsPCLWx4+e5dy7f+TIW5dJNCUZHBigq6uLjo4OHWSqqGDJWI73Ll/io9//jsd379L3VJxqjQIsiFsDnvje+7zzT3jt2t+IJ5q0DBSgarRLSllYXs66Vavg1t9RP0emDkpcgq7OTq3VWYCKqadePs/Llz7kwLmLBAI1BCRIBeqRk5KMRiPLxse5duUKv716lZ1bt2qpBGtqivorClv9qjAZMRnLMVdVFkeu8NZCsGJQZWo0mfR16WiWxunRqwtH9HFpg3AUWSuUoR5W4xWJ1MtMB3HM3CuNmQUYrQ8RCfmxW4yYzebiUZkUAAOBapoSjQQDPpGSVd8rnFklO8SWQpnNxO6dIjK6h0h9VLQV1fpSOrTZ7PKiCqpjQ7R87iIdW64QG/k8fT3tNKdaNHmlxBicbj+dW94hdxjSkzdp7+xh8eIxxsbGNKjVKvZlNrKoYzUjz8OSY5Bc+RKZnlaWjE/QKUyXEiMZeuh79H3G9kN2x3WCtXXEGyW7cHgmSIRrLqc2dR+9Oz8ivfPP1A/vweM0Sz9rtfirqqpKShbZ+DbuJfDkNL6tBwnU1hIM1hAWwEAggE2CrJVmIpkW7j/zGGvffIqu9UtplNbEE3ESose2tjbNuM7QLiN298EvM//HF/jkV0+TSKUYEy8czeXyJSsCKswkJtrY8pun+cJfXyT35P30tHYxJq1RE6MsrNhDNcuGE0cwfP87GKZPEopEaGttlYandLM1oMlM40Q7G36xj/W/3Ed62zg+p5dQuE7LaVbJTgHM7niaiRdeYWjyEIGaoLZ1BaberMo2GU1kBzOcfeM0599+nQ0Preee8D3E43F9CoToDH1eP2ee/S7XL8JPz9ygtaWN4eFhYXkxfWJh0WiU+QsWsGr5Cm7d+FjP8ovPPkeX+N+I2FdKKin0TwOqJXT+1DWu/wx++NpNGmNxLQXV6EJftDmsXg3/yJvDwf37ZZH59MvUtJSOqcEpwl6/ZgdffOQQD39mUvufxWopBqkHVAZhEfkSIWtC9JkUZlXfSl2mqEO7w86ChWWU3T2PhcYFt13e2hwEtFxcp1yyrZKxvN0c5ydFbrSIqabiCXyiyYL7lrpw4a+aCHUKdn+7rwfJ0IFPmPI0J7GKmNUDbnWU/Zc8+N8A/gPQoi42P8y8yV0YHtpIXJaUsvacCFtJQrnOnQAVAW2SRdnmTRi+tBfD1i3Uy3R0i4O0t7fr8Stt/B0B2gWwat19VD66kcoHVuOR7xr3zALXi34O5eZ3itfN8uOfZdPVfXzqrW0kkglZ9Fm9uJWwa2RvlAr3jgDXfn0b22++xIYrTxATVx7oH9CbT43gXMrN+6HLyYpjD/LAtx9j5alNeP0+LW6P1zOr3DtmWe3lPcdf5ezVGxyWRa/2rVreihRlTXMmRQEeu/Ael2/B1z74i/5y6O/P6pKVNc2FkHwPhclnznyTV37+Bw698SNtXzViWdqtbzOr/7+HhT2sRmrmw0exWsrsXLL8FwlnuTx0ZK2jAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/d5b6e3abcb46fd4f4cb42510085ce616/09548/alts-dark-3sm.png",
              "srcSet": ["/static/d5b6e3abcb46fd4f4cb42510085ce616/d6747/alts-dark-3sm.png 288w", "/static/d5b6e3abcb46fd4f4cb42510085ce616/09548/alts-dark-3sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "19.827586206896548%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsSAAALEgHS3X78AAABEUlEQVQY01WPz0vCcADFvdcYc9/9cq4pLtRyIkXWXKZSiEVCBEKUZIcwqUMFxQ5Sh4igS0XnOvQv9A9+mh6KDg8ej8f7kfCdNbx0Ed0UOCmPfKZGKmWhaRpePsDNFtC1JLZbYr7cwUnb6LqOtlgmnfOwTGPqnWgTJFrrbzQ3hlhzMitum5vwA79SwtIF7uCdys4AR5Vwgw7h1QulYj4u0LFG+/jtBhnbQQjxF+g/PlE9PkEoMrvVBt/RK4WFIoZQWb57pnbQx5QV6ntNxl/35LI5hKpy9vnAVq8bF5v/Fx5d3NLqdJFmZwhrAeMoii/bKEmF0WHEZn0bSZaoByGXw3MMw5gu6p1es7Qaxlz9DZvgB2h2fcuk3ZNVAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/2f8d94014321f1c0c43ec0ef93b9de0e/fb070/alts-dark-3.png",
              "srcSet": ["/static/2f8d94014321f1c0c43ec0ef93b9de0e/d6747/alts-dark-3.png 288w", "/static/2f8d94014321f1c0c43ec0ef93b9de0e/09548/alts-dark-3.png 576w", "/static/2f8d94014321f1c0c43ec0ef93b9de0e/fb070/alts-dark-3.png 1152w", "/static/2f8d94014321f1c0c43ec0ef93b9de0e/fb104/alts-dark-3.png 1728w", "/static/2f8d94014321f1c0c43ec0ef93b9de0e/cf416/alts-dark-3.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "19.827586206896548%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsSAAALEgHS3X78AAABEUlEQVQY01WPz0vCcADFvdcYc9/9cq4pLtRyIkXWXKZSiEVCBEKUZIcwqUMFxQ5Sh4igS0XnOvQv9A9+mh6KDg8ej8f7kfCdNbx0Ed0UOCmPfKZGKmWhaRpePsDNFtC1JLZbYr7cwUnb6LqOtlgmnfOwTGPqnWgTJFrrbzQ3hlhzMitum5vwA79SwtIF7uCdys4AR5Vwgw7h1QulYj4u0LFG+/jtBhnbQQjxF+g/PlE9PkEoMrvVBt/RK4WFIoZQWb57pnbQx5QV6ntNxl/35LI5hKpy9vnAVq8bF5v/Fx5d3NLqdJFmZwhrAeMoii/bKEmF0WHEZn0bSZaoByGXw3MMw5gu6p1es7Qaxlz9DZvgB2h2fcuk3ZNVAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/2f8d94014321f1c0c43ec0ef93b9de0e/fb070/alts-dark-3.png",
              "srcSet": ["/static/2f8d94014321f1c0c43ec0ef93b9de0e/d6747/alts-dark-3.png 288w", "/static/2f8d94014321f1c0c43ec0ef93b9de0e/09548/alts-dark-3.png 576w", "/static/2f8d94014321f1c0c43ec0ef93b9de0e/fb070/alts-dark-3.png 1152w", "/static/2f8d94014321f1c0c43ec0ef93b9de0e/fb104/alts-dark-3.png 1728w", "/static/2f8d94014321f1c0c43ec0ef93b9de0e/cf416/alts-dark-3.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <p><strong parentName="p">{`4-Color`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.55555555555554%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAfCAYAAADnTu3OAAAACXBIWXMAAAsSAAALEgHS3X78AAAE+UlEQVRIx51Va2xTZRiumMXh2rVrey5tT69rd+ll67obG1u3dqNbB0xAAce4iIGICSoMhQ2cijGiIxOFhOCcCtnEIEl/EAZjykUTxiRGJYsuSoYhJMbbD/nhL388vt+3dXaDuM0m3zk953vPc97nfd73OSpRFGE0ChCMIiRRAru+d9G+IMJAcaIo3zdGEAR+VrFDMOSHt8ADg5AJg8FALzDyxf6zQIPBiBy3C6UU57DKMOh1BD49JglKgBJC2Q0o9zwKv7UOVqsViqLwZbfbYTKZYTRkweoOIq9iNVyhZiguH+w2BRaLApvNNj1DyWhBZ8MoDseA3WU3EQqFEIvF0NDQgEgkgpycPOg0DyE3+hwir/+NuoNAaOnzWBaPIhKtQ21tLSRJ+hdQFgmw9Af0hIGXim/D6/WiqmoxAv4AsrKyIEpEUZsOX+xFNL0FxAnQG3kWxcF8VIdr4HK5OO0pypJoQrz2GFqWfoZlkfc5VbPZzKmbTCYIVBKjTg1HeB0K2y+iYNd5OCpWwCIZoVhtRNsylR3PUKAbaYcPYMHwBSw4+R6CwSDq6upQv2QJ0c2BngovZWqhXbMKaecSSLt8DsJjKxGrrkY9laasrGwGIGWT1tuDBSPDBNgPv9+PKNWuqqoKDoeDlBcgaTRQr2+FavhzqK5egXHtGoSLi1FDcYWFhdMBRVmG+80u5H58CtkHuzlNtsGoMOoCFdyYqYG9eRX8x0/B29MHeywOWa+HRM8mSzQlikWx4o0Pz2Do5l/oHfyaU25sbEQ4HEZJSQk1vACNNgMbVjyNkZM/40biLjav3o6KxYt4Nyyh0pSWlvKe5IBm6qUT137ENwBOf/cbV7myshIlk0GybEKGOh3bNnbi9gj42rR2BwqCVBpqG6aynrKdUlkmiu3vnsWRT8exr/c8T1+ZpMuCJGobtSYDrauewqVPbuJc3ygeaXycJkVPnWCjF8rTayiZFHhX96P8hTsIbL7Es4tGo5wKE4hlqSZRtjyxEWNfXcOdsVFs2/IkFpNo9fX1vCy8X1MBa/b+hOZeILL/TwQCAQ7IgFnB2RSkL1yIlzs6kPztaWtDsKgIFRUVXLxk/SZmWTIh1HoClc8MI7T+I64yC2JUWJBMgGq1GhtaWnB1aAiXBwawcvly6CgrFpc6xxN9SBdZOg0tNTcBds3emOog7MzGS6vVQqfTTTlMct1jXz5SNj83j/sh22A07+d17P7MvXsyZAePzwe31wdxkgJrg2RdZj7wX/c4oIHeqN/bjgePvIMH9u7hooTZnJKCfJYne2yuS2Wg4msOdUOVOA1VdxcKCgq4D1YTqMfjmbKmOQMKDLB9Nx4+/DYy9rXzhjaT0kztVOOcMyDrtb6eHox/ewMXEgneqCw71odOp3P+GVoJ8Pvr13nD/n7rFv8EsCkposb9XxkyahfPDuDX8XF8MTjIG5plzc7JkZoPqEoyK8jb+QFCx8bge2WAu82iReUoJgNl2c6bsmS2wn90DGXDQKD/Dw4Sj8d5Hd1u97R+nBOgSH6Xv/8iAr2/IPfVKxMfqEkXZpRnjtasgLKFvnqHtmLTpdew4vgO5Ofnc6WZmzClU91kbqIoJmw424aOu0ex9ctO/gloamriFsYmZaaBzl5Dk4x1iZ3YPtaF1jO7YCMXzs7OhtPlvK/rzF5DOigeO2xeJ6w5Dg7C5jdV3flk+A/1p82umY3e2AAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/5a12e0fff5bbc5c13b96221ec578ce69/09548/alts-dark-4sm.png",
              "srcSet": ["/static/5a12e0fff5bbc5c13b96221ec578ce69/d6747/alts-dark-4sm.png 288w", "/static/5a12e0fff5bbc5c13b96221ec578ce69/09548/alts-dark-4sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.828947368421055%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABvElEQVQoz3WSvW/TQBjGs9ACQa7jj7Mjp6mjJrVjO74mRqFqoXwJFRohPsrWhTEIAkh8biwINiQKDHQBIcQEExNsDIiBSrDyByCkCsSf8OPiCgaUDqfTvXre3z3Pe1ewPY1SSccwDGzbxnEEVc/CNifQ9ZKqWViqXimXmXZdDH1LK1RNCJH3DPe/q3A+fUEct0hlSlk1CeEwe/oB6dFLZLMJk1M+lqYhOm3GLl6g0W6TNJvYI2A58NaJ70jZJggDbMtCOC77bmyQrT4iS8MtYLGIWFxEPH9GvDBPGkVK54wGFt68RHY6tOIYyzQRKlZh/SHF6wPmpcSv1dgxNs7qyhn49YPe8SWmfH8kLAcOPnymlaZEwxjKoaOA/bW3nLtyl1YUEsUJ2u6ddI6d5eb7TbKFw0TBjJr1Ng5fb/wkTSWNeh1TOXTdMu/Wv3L/2hMawTRVv4a5Zxzv4AozrzZpzh0iDurbR95/5zfZ3i5JEuXA4cN8+fSRp4/XCMMmlckKE7s05MkuV7/do3tkDpnIXDcSGC3dxvMquOpGK/82DoN+n1O9HuZwBOps6gY12eDA5WWqdR9XuP9g/0P/APOW9tJAekHuAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/e616231093b495e14bf8a3ac595c254c/fb070/alts-dark-4.png",
              "srcSet": ["/static/e616231093b495e14bf8a3ac595c254c/d6747/alts-dark-4.png 288w", "/static/e616231093b495e14bf8a3ac595c254c/09548/alts-dark-4.png 576w", "/static/e616231093b495e14bf8a3ac595c254c/fb070/alts-dark-4.png 1152w", "/static/e616231093b495e14bf8a3ac595c254c/fb755/alts-dark-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.828947368421055%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABvElEQVQoz3WSvW/TQBjGs9ACQa7jj7Mjp6mjJrVjO74mRqFqoXwJFRohPsrWhTEIAkh8biwINiQKDHQBIcQEExNsDIiBSrDyByCkCsSf8OPiCgaUDqfTvXre3z3Pe1ewPY1SSccwDGzbxnEEVc/CNifQ9ZKqWViqXimXmXZdDH1LK1RNCJH3DPe/q3A+fUEct0hlSlk1CeEwe/oB6dFLZLMJk1M+lqYhOm3GLl6g0W6TNJvYI2A58NaJ70jZJggDbMtCOC77bmyQrT4iS8MtYLGIWFxEPH9GvDBPGkVK54wGFt68RHY6tOIYyzQRKlZh/SHF6wPmpcSv1dgxNs7qyhn49YPe8SWmfH8kLAcOPnymlaZEwxjKoaOA/bW3nLtyl1YUEsUJ2u6ddI6d5eb7TbKFw0TBjJr1Ng5fb/wkTSWNeh1TOXTdMu/Wv3L/2hMawTRVv4a5Zxzv4AozrzZpzh0iDurbR95/5zfZ3i5JEuXA4cN8+fSRp4/XCMMmlckKE7s05MkuV7/do3tkDpnIXDcSGC3dxvMquOpGK/82DoN+n1O9HuZwBOps6gY12eDA5WWqdR9XuP9g/0P/APOW9tJAekHuAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/e616231093b495e14bf8a3ac595c254c/fb070/alts-dark-4.png",
              "srcSet": ["/static/e616231093b495e14bf8a3ac595c254c/d6747/alts-dark-4.png 288w", "/static/e616231093b495e14bf8a3ac595c254c/09548/alts-dark-4.png 576w", "/static/e616231093b495e14bf8a3ac595c254c/fb070/alts-dark-4.png 1152w", "/static/e616231093b495e14bf8a3ac595c254c/fb755/alts-dark-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <p><strong parentName="p">{`5-Color`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "94.44444444444444%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAAAsSAAALEgHS3X78AAAEG0lEQVQ4y2WUa0xbZRzG55ZgGJfez+npDSgOYZS2lLa0tGvplQrohmzGCRtjEg1qMBHdZjIcJrLEmW0xfpnMZS5T0Rk10egwM4iDuaAhyzQLXhLnJUv8YpRvfvv5nsNKwDU5PW/Pefr8/8/zf953gyRJmE0WzGYJSZJRf995WbBYJExmy23MnTiLxaLdN6hf/oCHRm8dJkkniM2rl8lk0oAmsb6ntoZQi5cal4LZqNeercUUSTXC5to84S09eJxpHHYHTqcTu91OVVUVNptNKDDgcHuoj/TiDtwv1l5cToeGUbHrOpTNNg7nv+PVHBxq/QVvk4/CfQVyuTzpdJqtjR505XdTFxskM/Ev2eMQ2D5OV0eKVDpDJpPRiq4SWiUbY+EfeT0J48FbNG71EI/H8Pl8GI1GJNmKSVdKffsInYKs8wR4CmMEvPeSbE9RV1enyV6VLEsK3dsm6S/MsCNxDofDKSoq4u5AURQsYgBmfTlVQm7zgRn8o5dwJ/qwySbsjhVr1km2iAclJ4+yae4zNr7zBl6/n3QqRTabpaGhAaOoLut06LsKlHzyPiWzFzH27yYTbSObzxOJRJBleQ2h0F9yepJNC1fZ+N4UHq+XrPAlkUjgdrsxCaBcUUFlbw93zc+yYeEKhv37SLS0kBK4YDD4v9hYrVS9fIyaqXdxHT+BIgpI4qVqtGa2Wr2yEnuhky1vTlF75i2cD/RgNRqQxX9VjGZNkdAuvJo48xGfLv3D5PQifiE5L6TE43HC4bAGrNSV05Pv4/L537j24TLDfQdojYSELTmRhhxtbW0aThuKTeTu7PwPLAIfLP2Fp6lJm3LrbW+sYsplFaXs2TnCza/h1rfw1OA4Tb5GLVr19fXrp2y1Khw5O83p+d956e0ZbWrqVcyWSlheUUZv1wBfXrjJpamfeaTncTEsvQi3a91AVoKtOGjcdY7IqAj14Beisyjt7Ukt1E2iW3V7VQgPdz24g+tX5/j1xnWefnKYSDRKSqRBnbKW17WE8YM/0T0J7S8u4/X5hZSsNmV166kdlG7ezMjwMMXP0SPjNAcCJLYlqK6u1oquEkqyQmzoY9KCNPrYNKqnqlx1gkVvysrK6N/9MEvXFvn+mwWG9g2g0+s1a4oHyaqHDquNqYee549nznN58BV8Xh8dHR0kE0lisRiJZAKb2E1N3SEGPj/I0JUXiO3PEfYHhT2tRIX0UCiEwWBY6dCh2LjxxCk4tsDfz13ALyR3FARhMqkFu9pdg6nCQHhvimf/fI1Dy6dIj24nFoySEdaoMVt3OChiihf3TmgdzooO1eNL3ceqf6pks8WMoVxPYGeMobkxHv3qMOE9KeziUKkRBVXZ62KjLtQuq2wOXIp99dAsgopA2SqjOMWucNm0dRGz1j/1/h+BpoTqVVfBUQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/6fb03ff8a1b7927f3915d8e6cd03332e/09548/alts-dark-5sm.png",
              "srcSet": ["/static/6fb03ff8a1b7927f3915d8e6cd03332e/d6747/alts-dark-5sm.png 288w", "/static/6fb03ff8a1b7927f3915d8e6cd03332e/09548/alts-dark-5sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "44.73684210526316%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABY0lEQVQoz5XRu0rDABTGcR1Fo8Rc2vSKmKQ2oUlr4w2CWixWEPFGFwVBLDgJUgeRinPxARxFEcXNxc0X0EGxYHERX+WvBmdNhwOHM/z4Pk5XLKkRSciIoogsyyiKgqZFSSUiSIMikiSjqmpw/5mf/a/pKpu71HLXWJaFbdsoskjKnGBy6w5nvIJtmSi/4H9YAPqTR2xWn3DzLsO6jjQgkHBncZrvuKVV7BEDWVFDYQHYs71J9+UZhUIBM5NBEgSkcY/u23PMhXny2WxnCdf3D2k+POI4DoZhMPCdcNSb4eyizVx5mVzOIh5PhAeXdk44vmpTLI6iD+v0Cb1MT5V4uf9gbamKYRqonVQ2yg3G9lpB5YxpIgj9lGam+Xx7ZX11hXQ6HRoLwEalRqt+g+d5OK5LVI6Q9R3qz6f4yyUcK0dU08JXXnF9TuY2SCaTaLEYkiiRsobwDxbR3QxxLfb9FCV0wi/EjwivozXSJgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/6469e4e2338995e6b3f8a7ff389ca60c/fb070/alts-dark-5.png",
              "srcSet": ["/static/6469e4e2338995e6b3f8a7ff389ca60c/d6747/alts-dark-5.png 288w", "/static/6469e4e2338995e6b3f8a7ff389ca60c/09548/alts-dark-5.png 576w", "/static/6469e4e2338995e6b3f8a7ff389ca60c/fb070/alts-dark-5.png 1152w", "/static/6469e4e2338995e6b3f8a7ff389ca60c/fb755/alts-dark-5.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "44.73684210526316%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABY0lEQVQoz5XRu0rDABTGcR1Fo8Rc2vSKmKQ2oUlr4w2CWixWEPFGFwVBLDgJUgeRinPxARxFEcXNxc0X0EGxYHERX+WvBmdNhwOHM/z4Pk5XLKkRSciIoogsyyiKgqZFSSUiSIMikiSjqmpw/5mf/a/pKpu71HLXWJaFbdsoskjKnGBy6w5nvIJtmSi/4H9YAPqTR2xWn3DzLsO6jjQgkHBncZrvuKVV7BEDWVFDYQHYs71J9+UZhUIBM5NBEgSkcY/u23PMhXny2WxnCdf3D2k+POI4DoZhMPCdcNSb4eyizVx5mVzOIh5PhAeXdk44vmpTLI6iD+v0Cb1MT5V4uf9gbamKYRqonVQ2yg3G9lpB5YxpIgj9lGam+Xx7ZX11hXQ6HRoLwEalRqt+g+d5OK5LVI6Q9R3qz6f4yyUcK0dU08JXXnF9TuY2SCaTaLEYkiiRsobwDxbR3QxxLfb9FCV0wi/EjwivozXSJgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/6469e4e2338995e6b3f8a7ff389ca60c/fb070/alts-dark-5.png",
              "srcSet": ["/static/6469e4e2338995e6b3f8a7ff389ca60c/d6747/alts-dark-5.png 288w", "/static/6469e4e2338995e6b3f8a7ff389ca60c/09548/alts-dark-5.png 576w", "/static/6469e4e2338995e6b3f8a7ff389ca60c/fb070/alts-dark-5.png 1152w", "/static/6469e4e2338995e6b3f8a7ff389ca60c/fb755/alts-dark-5.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h2 {...{
      "id": "sequential-palettes"
    }}>{`Sequential palettes`}</h2>
    <h3 {...{
      "id": "monochromatic"
    }}>{`Monochromatic`}</h3>
    <p>{`The monochromatic palettes are good for relationship charts and trend charts. In light themes, the darkest color denotes the largest values. In dark themes, the lightest color denotes the largest values.`}</p>
    <p><strong parentName="p">{`Palette 1`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1024px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "57.8125%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAADU0lEQVQozyWSfUzUBRjHf/+0mi424O46EjgOCZQjbGcIBwfK7OTFJIbUdE4Lk4yEDSgYp4fnbJ1ukUtzucXUWlYT8CUjGxqYpJkdeLg47uV3x3GQwY0kIJNxwH36Qc/23efZ8zz7/vE8j+C9G8LXA4u0X1/Afk3itQV62h9y90qA374bp/uyl86L/dy45OD6hT6+b73F1dZfaG/9mUstV7lwvp3LbT8wNTmNcGZ3iC/3hTjzZogPMuawSFrkO4k97I7r4q3427zy7Gk2yA5jUHxIZng9SctK0SzfQeKyYuRPJhPxRCIrwtbgsLsRzpbDV1Vwdk+Io/p5jmbNY8kMUrXaRnnCTfY+d5uSmM/ZqLSQF9WEXtaAJmwbqWE7WfV0CVHL16B4KpnYcK1kKCK0NMzTYpzl6+p5mncFObl1hmNFE7yfJ2LcYKU2+wYVmRd5I/002188QanWQmFqPQZNJbkpZWRpStAmGtClFuJx+xBEt5e/xicgBB7Ry9hoYCkf/XMMn8/PwkKIyckpnA4Xjx79SzA4h9vlZmLib0JSz+8fZmRkhNnZIIsh/O7oZWTUu6S+fiu+YTcPxobod/TRP9DHg1E/TpedXpuVIb8Xj9eNra8X0ePCNzSIzXYPh2MA/7CfQGAMYXvOYUozD/BqtomyokPs2tzIzkITe7eZqdhhpvw1E5VlB6mtOETVHhM1FY00vGemrrqRuhoTpv1mDuw/SH2dEZ0uE+GjbDiiW6ApF87tkw5U+b86muCnT6HzBPS0wUAX9HdI73UHxgch4IaHQzDzDwQfw/TEHBnpOoRPNkLTejieB+erJdVASy10HYdbzdB9Cu5/C2I3ODvBL/3s5LBkJplO/QFzM9LKpfU9noac7PUIxvRBjFkOzAYXlq1Ojr0ucvJtkc/edfFFo5tvjnho+9jFlWYXHec8/Njq5ma7k187RazdIr13nNjve7lntZOWlo5QsKkI7QvrUMWspGDTFrJ0OahVCeToczG8lE/CykTWpWXw8uYiNMkppGiep7i4hLXatSQlrSI/vwC9Xk+8Oh6FQoEQp1Yhk0ciV8hRq+NQKp8hUhZBrCqG6OgVRESEEx0TjUoVK+URKKOU0pwamUyGXC6X6qolRkZGLvE/qduFfqUwdgQAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 1",
              "title": "Monochromatic palette 1",
              "src": "/static/b275c6036f149f7c8dbd0e9d7e5e9ef4/f935e/palettes-mono-1sm.png",
              "srcSet": ["/static/b275c6036f149f7c8dbd0e9d7e5e9ef4/d6747/palettes-mono-1sm.png 288w", "/static/b275c6036f149f7c8dbd0e9d7e5e9ef4/09548/palettes-mono-1sm.png 576w", "/static/b275c6036f149f7c8dbd0e9d7e5e9ef4/f935e/palettes-mono-1sm.png 1024w"],
              "sizes": "(max-width: 1024px) 100vw, 1024px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.94736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACyElEQVQoz32SW0iTYRjHPyIwIWy6g9t0lcuo1MrSysjMUS7BTIUogsgoCuyiA0Vmzc1jtbbSYpSEF2r6lV4JRQcIjIoi0ZbGIjpaayV2ICtttfn9+lwHu+oPP973eS5+PM/LK/zwS7x7IfG+D/ofS/g8Mg8l+nq/8rznM8/uf+LRvTchPN0v6e16ygMZd5eHrs4ePL2PGAmOMBpJkhDe9Um07JQ4v0eibv0I9owAzuVBdie72Z54i20J18iZ6iA3rgZTbAnz1RtYEL2Z6eplaCcmkpGSx/DQ8Jhw4Dk0boUGmRM5ElUpEmXJ3ymK62FTzA3WRV/ApLCTEVHNvAk7iB+/BuO4AtTj5hMmxDI7LpOhr/8IP/Z/41pjPzfPDdLRMEj7sbdcdn2g7cgTmirdiEfduA5ewWW7iKuinaq99Rwra6Sy5CTFuypwHa/H7/cTDAYJBAIIo+Yh/yB/EmT49y3wtxeQvjGWEf4X4ajDTrXdJmOl8tAoNiqqrJRXylRYsZVbsJWVhii1WmRKsZQexGKxhLDKtcPhwOl0hhB0EQmsi29mrbGZTaktbM8SKVousm+9yIGNIpYtIvb9IkeKRWrKRU4fFznlFKmva6G5qQ2HvZaIiEmEhYURHh6OkGJczWkzuEzQUgiXLHChGDrPgPssPGiVv1M3vOmEwSfyTp/kZ3k/tuLA2y8YjUY0Gg06nQ4h0WDiQFoftqVeDue+4kShl7oiH00lXtqqX9Ne6+Nqg5eOVh+3L76m+7qX3js+PPde8fLZADc67mIwTEapVIakwtQp0zAvK2DOjDRS5yzFnJlH0sxUTOnZZKabmZuUSk52PosXpZO2cAm5q/KZl5xC1oqVmM3ZJMxKCInUavUvoVarxTAlhiiVAp0+Gn2sliilghiDHk20GqUqSp4gVu5FyrUGfYwehWISer0OlUpFZKTir2z0/AmS8Ei+FyTSMgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 1",
              "title": "Monochromatic palette 1",
              "src": "/static/bba575d8822fc5438097892f011c0026/fb070/palettes-mono-1.png",
              "srcSet": ["/static/bba575d8822fc5438097892f011c0026/d6747/palettes-mono-1.png 288w", "/static/bba575d8822fc5438097892f011c0026/09548/palettes-mono-1.png 576w", "/static/bba575d8822fc5438097892f011c0026/fb070/palettes-mono-1.png 1152w", "/static/bba575d8822fc5438097892f011c0026/fb755/palettes-mono-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.94736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACyElEQVQoz32SW0iTYRjHPyIwIWy6g9t0lcuo1MrSysjMUS7BTIUogsgoCuyiA0Vmzc1jtbbSYpSEF2r6lV4JRQcIjIoi0ZbGIjpaayV2ICtttfn9+lwHu+oPP973eS5+PM/LK/zwS7x7IfG+D/ofS/g8Mg8l+nq/8rznM8/uf+LRvTchPN0v6e16ygMZd5eHrs4ePL2PGAmOMBpJkhDe9Um07JQ4v0eibv0I9owAzuVBdie72Z54i20J18iZ6iA3rgZTbAnz1RtYEL2Z6eplaCcmkpGSx/DQ8Jhw4Dk0boUGmRM5ElUpEmXJ3ymK62FTzA3WRV/ApLCTEVHNvAk7iB+/BuO4AtTj5hMmxDI7LpOhr/8IP/Z/41pjPzfPDdLRMEj7sbdcdn2g7cgTmirdiEfduA5ewWW7iKuinaq99Rwra6Sy5CTFuypwHa/H7/cTDAYJBAIIo+Yh/yB/EmT49y3wtxeQvjGWEf4X4ajDTrXdJmOl8tAoNiqqrJRXylRYsZVbsJWVhii1WmRKsZQexGKxhLDKtcPhwOl0hhB0EQmsi29mrbGZTaktbM8SKVousm+9yIGNIpYtIvb9IkeKRWrKRU4fFznlFKmva6G5qQ2HvZaIiEmEhYURHh6OkGJczWkzuEzQUgiXLHChGDrPgPssPGiVv1M3vOmEwSfyTp/kZ3k/tuLA2y8YjUY0Gg06nQ4h0WDiQFoftqVeDue+4kShl7oiH00lXtqqX9Ne6+Nqg5eOVh+3L76m+7qX3js+PPde8fLZADc67mIwTEapVIakwtQp0zAvK2DOjDRS5yzFnJlH0sxUTOnZZKabmZuUSk52PosXpZO2cAm5q/KZl5xC1oqVmM3ZJMxKCInUavUvoVarxTAlhiiVAp0+Gn2sliilghiDHk20GqUqSp4gVu5FyrUGfYwehWISer0OlUpFZKTir2z0/AmS8Ei+FyTSMgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 1",
              "title": "Monochromatic palette 1",
              "src": "/static/bba575d8822fc5438097892f011c0026/fb070/palettes-mono-1.png",
              "srcSet": ["/static/bba575d8822fc5438097892f011c0026/d6747/palettes-mono-1.png 288w", "/static/bba575d8822fc5438097892f011c0026/09548/palettes-mono-1.png 576w", "/static/bba575d8822fc5438097892f011c0026/fb070/palettes-mono-1.png 1152w", "/static/bba575d8822fc5438097892f011c0026/fb755/palettes-mono-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <p><strong parentName="p">{`Palette 2`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1024px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "57.8125%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAADOElEQVQozzWSf0zUZRzHn/7JtNUccD/k7vDACMoGKfHj6hC68kSByrJwTiYSKyvMGctFHj+yTVnr19JV/1QbfRsDFbcma0Nyc86hu4D0OO7u++U4DvXcnf2AHLQO/L56uNVne+/z/uzZ89qe9+cRgz6d835Y7n3DOr3/6YfzsyjnfkMZ+gPlpxmUsyrKQBjlRz9K/xWUM17ZL6OcHOL73nP0nP6ZP2fvIEo6dFzHdMo6de7dfVdKZ4XswuVHPHUFsWkMUXAK8dAJRN43CPtRRHojwviG7HsQq5yIFWWI1ZVc84cRjiPwbBc4PoD7G3RW7dFZWb+EcAckzIuolMAN/Yj8rxCPSGBOF8L0GmLNWxK6F/FAZQp6T5pLAqcQL36+SN3xJbZ9tETJ4UXWtyTJa/6L7L1RrDt92HZ4sdYOYnGfxPZMN9ZNJ7CUHsFa/D62ogPYChsw5+9g3cZdBNQoIhjSWPg7yXIFgiqzc3dSPjpzg5uxWykfT9xGmwyn/Pz8AqqqkUwm0XWdqUiEWCzG/yVC414SNydJxML4r3q5HgmRuDVNYHyM0MRV4rEooYCPa7+OcGMmQngyxOjIL0yFNaYjYUZHRwhM+IlGp4nH4zLv6g951O3hsSoPlXWdlL/chvMlD7UNHWxv7KCm3sOu19tp3N/J7n0emva3cfBQJ83vtPF2i4dWTwfvHW6n5VArDseTiJWNcF89rG6Cp49JyQW5pJq7obUPWnrg+BD0eqF7GAZ8MC5fOHYdJmQivy/A3D8ylrlFSsocctv74MFXwfQmuD+GLZ/A1k/hoAS1n5HQU/D1BTg9Bj0SOhiAYEJCJUy7LWEy/vm7EjwPzvIKufVXIqTVBclqUClsDuJ8V6WqTaPuaIimz0Ic+FLD851KV0+IL/o1vh1Q6RsKcvaixuCwygVvEK9vkksjfp4oLkVsrnqenNz1ZNpy2FqznYINxZgzs6hwbaa8wiW9lVKHE/eWbdiy7BQUPk7tcy+Ql5dPbu7DVFfXsLGoCIvVislkkv80247JaMBoyGBdTjaZa8ykp6exdm0WNqsl5S2WzNS87M1mM9nyTkZGBgaDAbvdjtFolGfpqflfiYNvYPf4Yz8AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 2",
              "title": "Monochromatic palette 2",
              "src": "/static/36cee1d367aede565558a5456e24069e/f935e/palettes-mono-2sm.png",
              "srcSet": ["/static/36cee1d367aede565558a5456e24069e/d6747/palettes-mono-2sm.png 288w", "/static/36cee1d367aede565558a5456e24069e/09548/palettes-mono-2sm.png 576w", "/static/36cee1d367aede565558a5456e24069e/f935e/palettes-mono-2sm.png 1024w"],
              "sizes": "(max-width: 1024px) 100vw, 1024px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.94736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACyElEQVQoz32SeUjTYRjH33AxhLK1uc05jxxlaYZZdI0u7bBDO/7ogCKKiLKMCqRzm/NIXZtFh1kU0R/5gwT/KEiosAiiZvc96c45Q//q0Flpv0+vXfZXD3z4Pjy875f3eZ5XhL+qBEKSVnj4TuX2S8krlcamMP5nHZJP+B+1SdrxPwjhv/da8gb/3SZu3HrC/ccv6On5Tm+oqooItKrM9qjkVKqM2qESteY70etUtDkBImbdQ5N1k4j0k2gyTqNJqSAicSOapK30tyxEDJxM8rhVdHZ29Rk+bQF7CUwsgrjNIJZLlnQjpj9HjL+DGH0VYTuBSDiKMBciotYiBqxGaGciRDp620I6OsJ9hs1tYXx17zl2uYuKug/sPN1OcW0n26peUlD1nN3VAfJKGth14DoF5fXkOxQcnjq27D7GpoJK9ledJdz1RbbdQ3e3fEiv87euj/wNNfw7+dJX6unknwP8L4TP68FXXsi+MieevS7KSwspK3ZSWuyixO2k2O2gyO3C7XJQKHE5HTgce3A6pO6R6nTi9Xrx+Xw/EVpDKprJNfSzK5jm1pC6XGHEUoUZ6xXm5yss2qKQV6Swwa2w3aNQcVhh7yGFIydqOHWmljLvQaKiBqHVaomMjJRzTl2APh8GbIB0uZhFx2HeEdh5DkovgrcB6l/A+SZofA+tchLv5AS+/m6xue0zNpsNk8mExWJBRA/NZOCyZvQrQiTnBbHvCDLbHWJlZZBN1S1ySSG5tCDVF0LUNLRQfzPIlbvyPz5uJvC2nUvXGomPT8BgMPw0FYlJQ7FnLcZqG03a2OnYM3OJSxrJlKwcxoyfxvCRGWTPX0xKWgYTJk0he24uKalpZM+Zx9RpmQxLHo7ZbMZoNP4yjIkxMyTRijFah9ViIiEuFoNeR7zUGLORaINe5lZZGywvmrDGWtDpdMTK9kzSZLDM/5j16g/wqDk4GbRVUQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 2",
              "title": "Monochromatic palette 2",
              "src": "/static/509c0e02cfd57ff568a177305a458480/fb070/palettes-mono-2.png",
              "srcSet": ["/static/509c0e02cfd57ff568a177305a458480/d6747/palettes-mono-2.png 288w", "/static/509c0e02cfd57ff568a177305a458480/09548/palettes-mono-2.png 576w", "/static/509c0e02cfd57ff568a177305a458480/fb070/palettes-mono-2.png 1152w", "/static/509c0e02cfd57ff568a177305a458480/fb755/palettes-mono-2.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.94736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACyElEQVQoz32SeUjTYRjH33AxhLK1uc05jxxlaYZZdI0u7bBDO/7ogCKKiLKMCqRzm/NIXZtFh1kU0R/5gwT/KEiosAiiZvc96c45Q//q0Flpv0+vXfZXD3z4Pjy875f3eZ5XhL+qBEKSVnj4TuX2S8krlcamMP5nHZJP+B+1SdrxPwjhv/da8gb/3SZu3HrC/ccv6On5Tm+oqooItKrM9qjkVKqM2qESteY70etUtDkBImbdQ5N1k4j0k2gyTqNJqSAicSOapK30tyxEDJxM8rhVdHZ29Rk+bQF7CUwsgrjNIJZLlnQjpj9HjL+DGH0VYTuBSDiKMBciotYiBqxGaGciRDp620I6OsJ9hs1tYXx17zl2uYuKug/sPN1OcW0n26peUlD1nN3VAfJKGth14DoF5fXkOxQcnjq27D7GpoJK9ledJdz1RbbdQ3e3fEiv87euj/wNNfw7+dJX6unknwP8L4TP68FXXsi+MieevS7KSwspK3ZSWuyixO2k2O2gyO3C7XJQKHE5HTgce3A6pO6R6nTi9Xrx+Xw/EVpDKprJNfSzK5jm1pC6XGHEUoUZ6xXm5yss2qKQV6Swwa2w3aNQcVhh7yGFIydqOHWmljLvQaKiBqHVaomMjJRzTl2APh8GbIB0uZhFx2HeEdh5DkovgrcB6l/A+SZofA+tchLv5AS+/m6xue0zNpsNk8mExWJBRA/NZOCyZvQrQiTnBbHvCDLbHWJlZZBN1S1ySSG5tCDVF0LUNLRQfzPIlbvyPz5uJvC2nUvXGomPT8BgMPw0FYlJQ7FnLcZqG03a2OnYM3OJSxrJlKwcxoyfxvCRGWTPX0xKWgYTJk0he24uKalpZM+Zx9RpmQxLHo7ZbMZoNP4yjIkxMyTRijFah9ViIiEuFoNeR7zUGLORaINe5lZZGywvmrDGWtDpdMTK9kzSZLDM/5j16g/wqDk4GbRVUQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 2",
              "title": "Monochromatic palette 2",
              "src": "/static/509c0e02cfd57ff568a177305a458480/fb070/palettes-mono-2.png",
              "srcSet": ["/static/509c0e02cfd57ff568a177305a458480/d6747/palettes-mono-2.png 288w", "/static/509c0e02cfd57ff568a177305a458480/09548/palettes-mono-2.png 576w", "/static/509c0e02cfd57ff568a177305a458480/fb070/palettes-mono-2.png 1152w", "/static/509c0e02cfd57ff568a177305a458480/fb755/palettes-mono-2.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h3 {...{
      "id": "diverging-palettes"
    }}>{`Diverging palettes`}</h3>
    <p>{`Please note that diverging palettes do not differentiate between light and dark themes.`}</p>
    <h4 {...{
      "id": "palette-1"
    }}>{`Palette 1`}</h4>
    <p>{`The red-cyan palette has a natural association with temperature. Use this palette for data representing hot-vs-cold.`}</p>
    <Row mdxType="Row">
      <Column colLg={12} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "90.27777777777777%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsSAAALEgHS3X78AAAD1UlEQVQ4y5WUe0zVZRjHf6HNolmxVBiKlGSWaxrkXFm2RZtbDZ2ZmFuXrct0DEyDbtaMFWRMqTCC6VgmhK1xU4dBSAtLI67BYIpygNM5XM4FQQ4HzuV3eT+95xxq/gGrnu279/fH+/u83+d5n+dVuCGEIRBibnHDOpeUwIZprxdV15gtxH9R4KCZ/UFgT1cXFpMJ1T2F3+VCc7vRJ1wYU9MgD8Mjparg94Ouh2QYIcLf64x7RZU/lKekcXj9Bkoff5Ifnt5Mw2OJDG7diTXxGawvvY5n9xvYs3Lw5RVwvawKV/WP+H5vwdnajrAOYuvvR5dGgg4DwCNPJLL3loV8uTiab2PiOBsVS999DzFw92qcTyXhTUrmevp7qAeymC7+Dk/5afwNF3AFgANmxi0WjImJEFCXqRxe9wh7bg7nq8gYiqOWU7M0jt7oezGvikffvANt2wuQeRCyD0HFGThbB9IhvX1gtsDUFMgyBVPWZF0+f3Rj0GFBdCwly1ZQs3wlptgHMN+fgLrledTnXkRkfoKQQCGBoroO0diCuHI1CBSBdCcnQ7ccAGavXkOqopC74HZKwiM4t3AJlyKWYl7xIKMbNzEp6+nfkxGEcuw4ovwUyJRF9yWM/gE0mw1Vphx0aGgaddmfUrk7lXOp+2hKS6dn79sMyZqNHshm/FAe7qPH8Z0sQ6+uRf/5F/SWP9B7rqJbh9AcTvzXxvDJtMU/fShderTZ+/D/RhA4OGwLyu03cPkMRqd1RqYMrC6dy+OCy2M6nXaVDrufNqubVsskbeZxWk1O2kw2mi+Z6e4fxgg4DFB7bWOYnJP8anFT1mXnxBU/79T+SUazYO3XFhIqfETldHFn7gDLcrpZ8mETt6WcIWbXSRZs/YK47Zms2pmNT9VCwEGXD4tLpdGuUWPxc6LXILPZy74mwZoyL2srdRYdGeKOvGFuPdDOvLcuorxayfzkIsKScrlpQxorkj8KAQMpO3xgk9PVfA3qbVAs2yu7E9IlMF62Xfwpg0UFo0TkO5i3vxUl/QLKK5Uo244FgUrCLuIk0B8CgsMjGJFqHhXUjwhK+gRZHYI3JfBhCUw4pRNZ6OSufDsLPmgjLOMiYa9VEba9iPlbPkNZn8LKHR+HgIFmdLmnGRjz0OLQqB0SHJP9+m6bYGeDYJ0E3lPqZXGBg/CcPpT97Sip51FerkB59ijKpoMo8WlEJr0/U0MJVOX4ubwaTo+82Sl5q3IsA25/GhaclpP1vUmj9LKHbzonKGq9RuFvIxSeN1NY30NhTQf5VY2U1rWiy5dHEXO+grN9/3v8BX78oBld0o+ZAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 1",
              "title": "Diverging palette 1",
              "src": "/static/d5c3d7ca560fd6452d032a39afbe5901/09548/palettes-div1sm.png",
              "srcSet": ["/static/d5c3d7ca560fd6452d032a39afbe5901/d6747/palettes-div1sm.png 288w", "/static/d5c3d7ca560fd6452d032a39afbe5901/09548/palettes-div1sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.948275862068966%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA6klEQVQI1w3NPy8DYQDA4SNm30Bi6OQT2DuS2msxsJAYyFlNpmIxGJBqwnhhEAkRRCVshuZCxEIaXGmud6++d++9f346PPPj9ZOENIrIu130gI1jXCqwUmKVwmmD0ZosVxTWIQtLohy/meWnb+iIgk6SEcUCIXO8y9oWa94IwViJl/EJ0vI0etlH7x2ib5rY1zfUIProKe6/DbuhpnptKB1LRjffGVppMjx7hDe5ir8T4D0FJzSmZnicW6A9v8Tf+gZmvwEXV9AKcZ9fWCGIpea55zhvQ60Fi3cF1dOIykFIZfuWsl+nfvbAP4pbxBsPfFBcAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 1",
              "title": "Diverging palette 1",
              "src": "/static/b7b8e0abf65bfdbbd255a2e7888fc152/fb070/palettes-div1.png",
              "srcSet": ["/static/b7b8e0abf65bfdbbd255a2e7888fc152/d6747/palettes-div1.png 288w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/09548/palettes-div1.png 576w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/fb070/palettes-div1.png 1152w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/fb104/palettes-div1.png 1728w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/cf416/palettes-div1.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.948275862068966%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA6klEQVQI1w3NPy8DYQDA4SNm30Bi6OQT2DuS2msxsJAYyFlNpmIxGJBqwnhhEAkRRCVshuZCxEIaXGmud6++d++9f346PPPj9ZOENIrIu130gI1jXCqwUmKVwmmD0ZosVxTWIQtLohy/meWnb+iIgk6SEcUCIXO8y9oWa94IwViJl/EJ0vI0etlH7x2ib5rY1zfUIProKe6/DbuhpnptKB1LRjffGVppMjx7hDe5ir8T4D0FJzSmZnicW6A9v8Tf+gZmvwEXV9AKcZ9fWCGIpea55zhvQ60Fi3cF1dOIykFIZfuWsl+nfvbAP4pbxBsPfFBcAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 1",
              "title": "Diverging palette 1",
              "src": "/static/b7b8e0abf65bfdbbd255a2e7888fc152/fb070/palettes-div1.png",
              "srcSet": ["/static/b7b8e0abf65bfdbbd255a2e7888fc152/d6747/palettes-div1.png 288w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/09548/palettes-div1.png 576w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/fb070/palettes-div1.png 1152w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/fb104/palettes-div1.png 1728w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/cf416/palettes-div1.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h4 {...{
      "id": "palette-2"
    }}>{`Palette 2`}</h4>
    <p>{`The purple-teal palette is good for data with no temperature associations, such as performance, sales, and rates of change.`}</p>
    <Row mdxType="Row">
      <Column colLg={12} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "90.27777777777777%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsSAAALEgHS3X78AAAD0UlEQVQ4y62SW0xcVRSGD5SKpa/GNjE+aDW10RhT0mC1GixqrIl9qEFFbmmMWttaLFgk3qFQMRIRsIAFKdCrMRY7tFgupagtFpgi98twvw1lpoUZYIYzM+fszz0MxD5Yn7qS/6ydk51v/WutrXBLCCFuI27J/y/Fe9HpdODxuPnvELeVWM5i+d8SsLOth8H+URbmNRyzHtR5nYVZgcsp0FzgUeV1D2iyptD/1WK55bzUheJa8JCZUMm7W38kaVsN6eGtpG/v58RuQWGMh5JEM7+muDmXM8XvR1UaDDM0V9npN6r0XLMwPS4YHpiURjSfQy9w38ulhK1JI/qhMvY+Vk/8411kvij4ZqtG/lszHNurcSZthspMN/U/O2gqd9JzxUVfsx3rsMA8Oo3D7rOqeNwa74QWEXrPQWLXn2XXI5c5sLGHr7cIMl/SOBkHp+OhNgcuHYa2CuisgSEjWAfgxii4HLAwt9SyF/jeC8WErU1j5wYDex69QmJwNxmhErhN40Sc4HSCoCZbUHtY0HJe0FEtGDQKrpvEItAp5+0DSodul0Z0SB6bVx3k1ftOsfOBOj7YYCI5WCUjTONIpM7xPQJDiqA6S3D1JLScE5guw3iHwDKoYbvuwmFb8DnUPDqlGVfI3F9NflIDxZ/28lOyBcMhF1Xf6dQVaPx1SqfZoNNZK0H1OsMtOmaTzo0xHZvFw+xNVb6QJaD3o6pzuNzz3IlYBI6YJxmWmvZoWOVMR1QX3U6VznknRvss12ZsNFlv0GSx0jgxQdP4GMaREZoGBjH2D9DQ1U374CC616GX2mqx0Dozwy9TU2T39XFgdJSQP+rY1NlO0KkTBF04T2BWJn65OazN/pZ701NZnbCf+/fFERjxJusiolgfsxPV7ZYOJbDX4aDL6aTMZqPQaiVhYpwnJWxjRysrK8oJrKxAKfwBpSCflV+lEvDFJyh7dxMQG4t/+Gv4Pfc8D0ZG+4Bem0OaRr+UYX6eErudDyfNPN1vIrijjbsuVnF31W/4lRShFBWgpH6J8lnSIlCJiloEKpu3sC4yRu7B7ZvhkDyYpMrn5iiWLhPNZp7t62WTBK6SwKCqC6yQQH8JXHEoBf/PP8b//T34x8QQ8PobKM+E8nBUrA/ofY3T0lm73UaFhB2ZnuYjOfQdPV08YWxk9aUaFEMZSulRlO+zUNKSURLjUXa9jRIRgfLKdpSQp1izI9zXshfoJd90qYy55HZVlUZZ4KJc0hm5rGLzBPkjQ+T3mciTc837u5nchqvkXv6T3NpacisryTlr4Hh1DZqu+5ZyJ+MfekqoLgW2mv4AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 2",
              "title": "Diverging palette 2",
              "src": "/static/0452a6236da7fee253c879dc39516a2e/09548/palettes-div2sm.png",
              "srcSet": ["/static/0452a6236da7fee253c879dc39516a2e/d6747/palettes-div2sm.png 288w", "/static/0452a6236da7fee253c879dc39516a2e/09548/palettes-div2sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "16.056034482758623%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA7UlEQVQI1wXBv0rDQADA4VN338B38A0suqm4+QBCBRcXF6vQ1cHNKBREilBQEMW/IKKDglqpQycLoZS6SE0CjUmTSy6Xy8/vE6MgxhuERENN7BfIwJBGBSoxaGUweYHWOVIpUmMItMbLFE6a4EqJG0W4YYjj+0QyQZxYr8xN7rEx3Wa3pKiXNbc7Oc1Tjf2mcXoGf5jxFUsug4CV7z5TrSbjVxeI2gFj1S0mVsuImVmqR3XE83WH7eUbDtd7nFcyniz4PAP7BX468DcoSEaaX5XyHsfUPJe1rs1S64OF+zvmG8cs7luUNis0Hh75B8ISxVKc21lDAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 2",
              "title": "Diverging palette 2",
              "src": "/static/ab9ea8685fd4657fb40902e3885d2f74/fb070/palettes-div2.png",
              "srcSet": ["/static/ab9ea8685fd4657fb40902e3885d2f74/d6747/palettes-div2.png 288w", "/static/ab9ea8685fd4657fb40902e3885d2f74/09548/palettes-div2.png 576w", "/static/ab9ea8685fd4657fb40902e3885d2f74/fb070/palettes-div2.png 1152w", "/static/ab9ea8685fd4657fb40902e3885d2f74/fb104/palettes-div2.png 1728w", "/static/ab9ea8685fd4657fb40902e3885d2f74/cf416/palettes-div2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "16.056034482758623%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA7UlEQVQI1wXBv0rDQADA4VN338B38A0suqm4+QBCBRcXF6vQ1cHNKBREilBQEMW/IKKDglqpQycLoZS6SE0CjUmTSy6Xy8/vE6MgxhuERENN7BfIwJBGBSoxaGUweYHWOVIpUmMItMbLFE6a4EqJG0W4YYjj+0QyQZxYr8xN7rEx3Wa3pKiXNbc7Oc1Tjf2mcXoGf5jxFUsug4CV7z5TrSbjVxeI2gFj1S0mVsuImVmqR3XE83WH7eUbDtd7nFcyniz4PAP7BX468DcoSEaaX5XyHsfUPJe1rs1S64OF+zvmG8cs7luUNis0Hh75B8ISxVKc21lDAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 2",
              "title": "Diverging palette 2",
              "src": "/static/ab9ea8685fd4657fb40902e3885d2f74/fb070/palettes-div2.png",
              "srcSet": ["/static/ab9ea8685fd4657fb40902e3885d2f74/d6747/palettes-div2.png 288w", "/static/ab9ea8685fd4657fb40902e3885d2f74/09548/palettes-div2.png 576w", "/static/ab9ea8685fd4657fb40902e3885d2f74/fb070/palettes-div2.png 1152w", "/static/ab9ea8685fd4657fb40902e3885d2f74/fb104/palettes-div2.png 1728w", "/static/ab9ea8685fd4657fb40902e3885d2f74/cf416/palettes-div2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h2 {...{
      "id": "alert-palette"
    }}>{`Alert palette`}</h2>
    <p>{`Alert colors are used to reflect status. Typically, red represents danger or error; orange represents a serious warning; yellow represents a regular warning, and green represents normal or success.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "102.77777777777777%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAACXBIWXMAAAsSAAALEgHS3X78AAADRElEQVQ4y52Va2xTZRiAGxL/GIzbkC5cuhVBIQiEf45ACAyEOLwlagQSFQg/IPzAH0YzSmALt2ACiTHqRAYJGm+EGGFjWzam21AuYYzb2nPKutLC2DIGa097GL2c8/j2dIU6Bpl7kydv+53zPef9vvN+OTaeEuYgQ8eeFjbTMNBPn0GrriVSW2+hVdWgn2uFbje012AqDeBpwHTXwfUWDM1L/E61UCOcTOfeExixHhEmEvgXvY4nZyLqhKnCNDzP2Qm88yEcd8HndszyGVD2MubWAvhiITHPXkJ/5Qjj0zTl03/qWUtuCW8sewslfwpe50y8U2aivOAg+P46qNoOLgfmrjmwczZm2UuwbykxZR+h5nzCzZMHKSD0Zy7xvtosoX1Q6EwLA5ZwG2wR4U4R7pj1uLApJZskOIYIl7+NIsv1vviKMAvVXkjwg/WYUqHpKpQK51pSs3w67F8mwv0inCBIZSILtzhl6eNEWJcWBhcuRx2bz3W7EyXPgfuZ5/GXrJQ9LIXP8mD7NNnDqbL8ibC7iLhnD5HmsUSaciXnojXl0V8/RvawCpuRTHLrl6MEvzlAoOIgoZ+P0n/kJ6KnmtGVFsKN36H//SP3Gg+itxyWt17LQO8Fetxf0adW0Kt8S6izknj3DxgDN6VC0+SiqtLW2cEFr4qR1VNe/01Ot17jTFs7l1Q/Xfei1njvXY3zrSoXL/u4dNVPT9/Awx61pX50BYIEfZ2Cn+SDGCTT7dvTfRtP+zUCft+jtjYNtHCI211B/FJENBq2rhhG3LpmVRiN6WgPokQkR+M6EeF+YuDR6ZB7DDkAqZyJ1P/MWGY8lW0JI8m6ehfzflvN4mNrLIp+XcWGxvKHZy8zKXti9sOGCBO89vt67N8voPDwUpzC+APzefPEpscmZU980kMs4YrjGyk4tITpR0osJlcW82715v8IRxqW8A0RFlrCFcwQHIeKea/6k9ELi4+tJafiVSZVLpLqFpNbUUTJHxtGK0zi+udLPmooZU39Fj6uK2VVzaeUnf16dMLUzapb4WrbFXzeDnxqx7Bv8H8JfZ0+2t1uFEVBi2jpPntCm4xIqOvSzJGIRVLO9nC9NmLhsN+SUVSWiX8BqOKr09nLolcAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Alert palette",
              "title": "Alert palette",
              "src": "/static/a405e134333b2095b675dfa3bf12bb40/09548/palettes-alert-sm.png",
              "srcSet": ["/static/a405e134333b2095b675dfa3bf12bb40/d6747/palettes-alert-sm.png 288w", "/static/a405e134333b2095b675dfa3bf12bb40/09548/palettes-alert-sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "26.973684210526315%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsSAAALEgHS3X78AAABFElEQVQY032PPSwDcRiHm1gsJqJLEyyCicFosVgMEpNBrBarbkg6CIlEYpBc4mMyidSGVDpIU219DEcvbUNPRBCtvztc7/vhOpiqT/Iu7y+/580bcvVPjOwF3+kczn0Bnq5BvcQTCraWAS3Hoyhx/iJz9XqL4dQI8H2fRoQCWbFnACXci4jOwPow/uIgZmKKSioC6T5Wk7OEt8YY2pugINR60fO9xsJaOkupPcJNSwdibhLW+mG+C/toHJFqg7NOYolpWqURundGyVfvmgv1soocW+Ztc5v3kzgPhyt8nUpoyj7FzBJmWSKZj7NwvMGufICw9OYvW65LxbYIYut3noVBcNtwoPrh1veu6eNo5l/pP1nAD9VeXg5gt+VaAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Alert palette",
              "title": "Alert palette",
              "src": "/static/6ea55640310d2ea5cc6aa60d3b062be9/fb070/palettes-alert.png",
              "srcSet": ["/static/6ea55640310d2ea5cc6aa60d3b062be9/d6747/palettes-alert.png 288w", "/static/6ea55640310d2ea5cc6aa60d3b062be9/09548/palettes-alert.png 576w", "/static/6ea55640310d2ea5cc6aa60d3b062be9/fb070/palettes-alert.png 1152w", "/static/6ea55640310d2ea5cc6aa60d3b062be9/fb755/palettes-alert.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "26.973684210526315%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsSAAALEgHS3X78AAABFElEQVQY032PPSwDcRiHm1gsJqJLEyyCicFosVgMEpNBrBarbkg6CIlEYpBc4mMyidSGVDpIU219DEcvbUNPRBCtvztc7/vhOpiqT/Iu7y+/580bcvVPjOwF3+kczn0Bnq5BvcQTCraWAS3Hoyhx/iJz9XqL4dQI8H2fRoQCWbFnACXci4jOwPow/uIgZmKKSioC6T5Wk7OEt8YY2pugINR60fO9xsJaOkupPcJNSwdibhLW+mG+C/toHJFqg7NOYolpWqURundGyVfvmgv1soocW+Ztc5v3kzgPhyt8nUpoyj7FzBJmWSKZj7NwvMGufICw9OYvW65LxbYIYut3noVBcNtwoPrh1veu6eNo5l/pP1nAD9VeXg5gt+VaAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Alert palette",
              "title": "Alert palette",
              "src": "/static/6ea55640310d2ea5cc6aa60d3b062be9/fb070/palettes-alert.png",
              "srcSet": ["/static/6ea55640310d2ea5cc6aa60d3b062be9/d6747/palettes-alert.png 288w", "/static/6ea55640310d2ea5cc6aa60d3b062be9/09548/palettes-alert.png 576w", "/static/6ea55640310d2ea5cc6aa60d3b062be9/fb070/palettes-alert.png 1152w", "/static/6ea55640310d2ea5cc6aa60d3b062be9/fb755/palettes-alert.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h2 {...{
      "id": "gradient-use"
    }}>{`Gradient use`}</h2>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` Gradients are not yet supported in Carbon Charts. This exploration is subject to change.`}</p>
    </InlineNotification>
    <p>{`Gradients are good for highlighting extremes in a range of values. Use a gradient on single category visualizations only if needed. Multiple gradients are often inaccessible and are discouraged in our system. Gradients should not be used to represent any meaningful progression or divergence. Never use a gradient in place of a sequential palette.`}</p>
    <p>{`For the full list of approved gradient options, see the IBM Design Language `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/language/elements/color#gradients"
      }}>{`Color page`}</a>{`.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "98.1907894736842%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAECUlEQVQ4y22SbWhbVRjHL26dW1/SJPc1aRKbptlWk1rKNtvRMXSK+zDQ+UG0A8e+iUNQcOyD+k0ZCHaCEymslRZB+0VFRP2gIMjAqYMxddY6aNlLm7TJzUvzeu9Nnr/nnDTJNj3w4zn3nOf5n/957pFAAIfqQL1OjPsioZkiRq1WQ7FUhmVVUamUUalWQUQtJJbC0qqMOu4dTQmuXG2cyAYXSG4ksXwnhcXlBBLJ9XYFF0wsV3D52wz++MXC9WvA738Sri4Srtwg/LYCXFp28PX1LLJlp1WYyQF/3wLSJXZWzWZOK23BlSvAV1PAlzOEhbk6PvmsjtkvCNPfEC78QHj/EnCO5ayVGq5LRcKNJYJtV1EsbqJcqQpBy7KEqNTuEOG/4649asR8CrCKgO1YMLN5JmSzXtfbgtT6Idw+bf2QNrSlRdQ4kLu5ubqKRHoDt9bWkFhP3dvDarWM3GYGNbL/xx8hu5lDJp9jjpzWmm052PyngMLNPIrlEmpOrS249JNDn58p0I/n8vTzuyZdnUrS4ge3aeWjZUpcXKLUzDUqzf5K9VSBX4SI2Tb/qlAlbRF7QuQ4DhWLRRH5kGzWjyz7m4XbQPEOu9IqwVqrwUk4qCeZ6xTrTarSanHFZGzwx+YgncnCsu3W+xQ9zOZMK18yrVyRkxFkC5yslWGYm5yclTZNK5MxreSqaaU2GKmUtb6+bqXTaQH/NlmOFIvF7Ydjw3aME28Qvx+xHxPEhxlxPo+zGG+vb80lr6sb3q4O9O7aDtfObeh5cBu6GV2Mzh0PoJPPd25Hb68LHo8Hbre7gZj3QpYVeLxescb3pdDIBA09c5r6H3ueIo+/QHufmKT4k5M0+tQJ2n/0BB1++hQ9e/JVikSHSFFkMgyDdF0nXdMEocgeCoTCpKmqWJeU8ePwvzyH6EvTGHnlIsZfm8WR1z/GsbNzeO6Nebz41jxOv72APfF98DBHmqbB5+/D3vgI/OEodH8AejAMla0zUUialyV1d0Dp2gGZXd3T2QF351YLGD27OtDNoix7hZjKivS+EPyhfhg+PwxdE7G5JymqBlnVoeoGNMMn0O9C1fQGLE/T1K2oQWdznbvSdbHO3XGXUiAYwGA0wq5hQFZkKKoikFWZJaiIDEYwwPD5fMJB04miKCK/3x9EwPCLGr4nHYqexNlD3+PMxKd48/A83jkyi/eOTuPDYxcwc/w8FibP47tTUxiLDsPldQtXhqEjHA4j4Asi7B9AyPdQWzBk7EYseAjx0EGM9B/EaHgM+wYexYHIAYwN7sf44Cgmdo8i6OsTRdxdwN+PoegjCDExLtJnhNhBerOHXniUHrgVF9yyC70tepmjBj2MpgNeZLB+cwGdOWXPSNDc+xdCwBkV9sBZdQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Gradient palette",
            "title": "Gradient palette",
            "src": "/static/3539fdf8f971d3e7db1865fd7a1c1093/fb070/gradient.png",
            "srcSet": ["/static/3539fdf8f971d3e7db1865fd7a1c1093/d6747/gradient.png 288w", "/static/3539fdf8f971d3e7db1865fd7a1c1093/09548/gradient.png 576w", "/static/3539fdf8f971d3e7db1865fd7a1c1093/fb070/gradient.png 1152w", "/static/3539fdf8f971d3e7db1865fd7a1c1093/fb755/gradient.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      